export const hollandTranslation = {
  'Les lignes de commandes ont été mises à jour avec succès !':
    'De commandoregels zijn succesvol bijgewerkt!',
  'Le texte a été enregistré avec succès':
    'De tekst werd met succes geregistreerd',
  'La traduction a été enregistrée avec succès':
    'De vertaling is succesvol opgeslagen',
  'Texte + Traduction enregistré avec succès':
    'Tekst + Vertaling is succesvol opgeslagen',
  'Nombre de mots': 'Aantal woorden',
  Lingala: 'Lingala',
  'Prénom/Nom du client': 'Voornaam/achternaam van de klant',
  Bashkir: 'Bashkir',
  "La date doit être ultérieure à aujourd'hui.":
    'De datum moet later zijn dan vandaag.',
  'Contenu rédigé': 'Geschreven inhoud',
  'Nom/prénom': 'Achternaam/voornaam',
  'Mot de passe incorrect': 'Onjuist wachtwoord',
  Institutions: 'Instellingen',
  'Veuillez donner un descriptif au document téléchargé':
    'Geef een beschrijving van het gedownloade document',
  'Sichuan Yi ; Nuosu': 'Sichuan Yi; Nuosu',
  Suivant: 'Volgende',
  Kannada: 'Kannada',
  'Séparer les mots clés par un "enter"': 'Scheid trefwoorden met een "enter".',
  Allemand: 'Duits',
  Sango: 'Sango',
  'Min.': 'Min.',
  'un email contenant un lien de réinitialisation du mot de passe a été envoyé à votre email':
    'een e-mail met een link om het wachtwoord te resetten is naar uw e-mail gestuurd',
  'Chef edito': 'Hoofdredacteur',
  Croate: 'Kroatisch',
  'Nb de textes': 'Aantal teksten',
  Violet: 'Violet',
  'Ce champs doit être sup ou égale nombre de texte':
    'Dit veld moet groter zijn dan of gelijk aan het aantal tekst',
  'a été activé avec succès': 'is met succes geactiveerd',
  Népalais: 'Nepalese',
  'Nombre de FAQ': "Aantal FAQ's",
  Urdu: 'Urdu',
  'Analyses restantes': 'Overige analyses',
  Indonésien: 'Indonesisch',
  Breton: 'Bretoens',
  Livrés: 'Geleverd',
  Associations: 'Verenigingen',
  'Le client': 'De klant',
  'Révision demandée': 'Herziening gevraagd',
  "Une erreur s'est produite, veuillez réessayer":
    'Er is een fout opgetreden, probeer het opnieuw',
  'Mise à jour non autorisée car des textes ont été livrés':
    'Ongeoorloofde bijwerking als teksten zijn afgeleverd',
  "Pour ajouter un texte (optimisation d'un contenu existant)":
    'Tekst toevoegen (bestaande inhoud optimaliseren)',
  Gaélique: 'Gaelic',
  'La ligne de commande pour': 'De opdrachtregel voor',
  'Business/Management': 'Business/Management',
  Serbe: 'Servisch',
  "Merci d'indiquer ci-dessous vos demandes de modifications en prenant bien en compte nos conditions de repasses":
    'Geef hieronder uw wensen voor wijzigingen aan, rekening houdend met onze strijkvoorwaarden',
  'rédacteurs trouvés': 'gevonden schrijvers',
  'Kirghiz ; Kirghiz': 'Kirghiz; Kirghiz',
  Différence: 'Verschil',
  'en cours': 'in uitvoering',
  'Sami du Nord': 'Noordelijke Sami',
  Comparer: 'Vergelijk',
  Lituanien: 'Litouws',
  'Typix - Mon tableau de bord': 'Typix - Mijn dashboard',
  'Avoir au moins 8 caractères avec une lettre majuscule, un chiffre, un charactère spécial et ne pas être identique au nom':
    'Moet minstens 8 tekens lang zijn met een hoofdletter, een cijfer, een speciaal teken en niet identiek aan de naam',
  Webmaster: 'Webmaster',
  'Veuillez saisir des champs valides': 'Voer geldige velden in',
  Basque: 'Baskisch',
  'Exporter .csv': 'Exporteer .csv',
  'Confirmer le nouveau mot de passe': 'Nieuw wachtwoord bevestigen',
  "Pas d'options": 'Geen opties',
  'Banque/Assurance': 'Bank/verzekering',
  'Vos demandes': 'Uw verzoeken',
  'Coût d\u2019achat': 'Aankoopkosten',
  Tamil: 'Tamil',
  'Le texte a été supprimé avec succès': 'De tekst is succesvol verwijderd',
  'Mes Commandes': 'Mijn bestellingen',
  Zoulou: 'Zoeloe',
  Afficher: 'Bekijk',
  Texte: 'Tekst',
  Islandais: 'IJslandse',
  Russe: 'Russische',
  'Tous les textes': 'Alle teksten',
  Czech: 'Tsjechisch',
  'Comparaison hors ligne': 'Offline vergelijking',
  Téléphonie: 'Telefonie',
  'Valider le texte': 'De tekst valideren',
  'Votre text ne de doit pas dépasser 500 mots':
    'Uw tekst mag niet langer zijn dan 500 woorden',
  'Coquilles (double espace, « s »\u2026)': 'Schelpen (dubbele spatie, "s"...)',
  'le consultant': 'de adviseur',
  Coréen: 'Koreaanse',
  'Nb de Silo': "Aantal silo's",
  Validés: 'Gevalideerd',
  'non attribuées': 'niet-toegewezen',
  Néerlandais: 'Nederlands',
  'Voulez-vous vraiment supprimer': 'Wil je echt verwijderen',
  Rundi: 'Rundi',
  Regional: 'Regionaal',
  'Compte client': 'Klantenrekening',
  Global: 'Wereldwijd',
  'Tous les rôles': 'Alle rollen',
  Musique: 'Muziek',
  Perso: 'Persoonlijk',
  Kinyarwanda: 'Kinyarwanda',
  'Il semblerait que tu n\u2019aies plus de crédit d\u2019analyse':
    'Het lijkt erop dat je geen analyse krediet meer hebt',
  Bambara: 'Bambara',
  Sortir: 'Ga weg.',
  optionel: 'optionele',
  'Temps restant': 'Resterende tijd',
  Ukrainien: 'Oekraïense',
  'Chichewa ; Chewa ; Nyanja': 'Chichewa; Chewa; Nyanja',
  'Votre demande de révision a bien été envoyée.':
    'Uw verzoek om herziening is verzonden.',
  'Typix - Créer rédacteur': 'Typix - Maak een schrijvers',
  "n'existe pas": 'bestaat niet',
  Hindi: 'Hindi',
  'ne peut pas être supprimé car il est lié à des sites web':
    'kan niet worden verwijderd omdat het gekoppeld is aan websites',
  'Commandes en cours': 'Bestellingen in uitvoering',
  'Textes livrés': 'Geleverde teksten',
  Validation: 'Validatie',
  'Non attribuées': 'Niet toegewezen',
  'Voulez-vous vraiment désactiver': 'Wil je echt deactiveren',
  'Catalan ; Valencien': 'Catalaans; Valenciaans',
  'Nombre de textes restants': 'Aantal resterende teksten',
  'Ne doit pas contenir votre nom': 'Mag uw naam niet bevatten',
  Documentation: 'Documentatie',
  Kazakh: 'Kazachse',
  'Numéro invalide': 'Ongeldig nummer',
  'Veuillez saisir un texte ou importer un fichier.':
    'Voer een tekst in of importeer een bestand.',
  'Nb de FAQ': "Aantal FAQ's",
  Analyser: 'Analyse',
  Turc: 'Turkse',
  'Toute demande n\u2019ayant pas été précisée lors du brief':
    'Elk verzoek dat niet in het mandaat is vermeld',
  Wallon: 'Waals',
  Birmane: 'Birmese',
  Irlandais: 'Ierse',
  Oriya: 'Oriya',
  'Réinitialiservotre mot de passe': 'Wachtwoord opnieuw instellen',
  Cuisine: 'Keuken',
  'Haïtien ; créole haïtien': 'Haïtiaans; Haïtiaans Creools',
  'Vous ne pouvez pas supprimer le rédacteur':
    'U kunt de schrijvers niet verwijderen',
  Validé: 'Gevalideerd',
  "cet email n'existe pas": 'deze e-mail bestaat niet',
  Historique: 'Geschiedenis',
  Confirmer: 'Bevestig',
  'à cocher si le nombre de mots est différent par texte':
    'aan te vinken indien het aantal woorden per tekst verschilt',
  'Fiche du site web ': 'Website',
  Désactiver: 'Deactiveer',
  'Travaux/BTP': 'Werken/Bouw',
  'La fiche du website': 'De website',
  'Si le contenu ne respecte pas les règles du brief':
    'Indien de inhoud niet voldoet aan de regels van de opdracht',
  Norvégien: 'Noors',
  '0 rédacteurs': '0 schrijvers',
  indisponible: 'niet beschikbaar',
  Venda: 'Venda',
  Maori: 'Maori',
  'Textes revisés': 'Herziene teksten',
  'Status texte': 'Tekst status',
  'textes livrés en attente de validation':
    'geleverde teksten in afwachting van validatie',
  'Typix - Mon Profile': 'Typix - Mijn Profiel',
  'le client': 'de klant',
  Romanche: 'Romanche',
  'URL du site': 'Site URL',
  'nouvelles notifications': 'nieuwe meldingen',
  'Divehi ; Dhivehi ; Maldivien': 'Divehi; Dhivehi; Maldivisch',
  'Êtes vous sur de vouloir sauvegarder le texte':
    'Weet je zeker dat je de tekst wilt opslaan',
  'Veuillez ajouter un texte initiale afin de pouvoir sauvegarder le texte en brouillon':
    'Voeg een eerste tekst toe om de tekst als concept op te slaan',
  Xhosa: 'Xhosa',
  'Le contrat pour le client': 'Het contract voor de klant',
  rédacteurs: 'schrijvers',
  'Ce champ est obligatoire': 'Dit veld is verplicht',
  'Tarif/Mot': 'Tarief/Woord',
  Tadjik: 'Tadzjiekse',
  'Réf devis': 'Ref citaat',
  'Rechercher un rédacteur': 'Zoek een schrijver',
  Albanais: 'Albanese',
  Galicien: 'Galicië',
  Disponibilité: 'Beschikbaarheid',
  'Les deux mots de passe ne sonts pas identiques':
    'De twee wachtwoorden zijn niet identiek',
  Tibétain: 'Tibetaans',
  'Typix - Gestion des utilisateurs': 'Typix - Gebruikersbeheer',
  'Ossétien ; Ossétique': 'Ossetisch; Ossetisch',
  Tswana: 'Tswana',
  'Ajouter un client': 'Een klant toevoegen',
  'Séparez les mots-clés par un " Enter ".':
    'Scheid de trefwoorden met een "Enter".',
  'Zhuang ; Chuang': 'Zhuang; Chuang',
  Thématiques: "Thema's",
  'Nb mots/texte': 'Aantal woorden/tekst',
  Commerce: 'Handel',
  'Voir les commandes': 'Zie de bestellingen',
  'Nombre de mots par texte': 'Aantal woorden per tekst',
  'Lien drive...': 'Link drive...',
  'Hollandais ; Flamand': 'Nederlands; Vlaams',
  'Mon profil': 'Mijn profiel',
  "Ce champs doit être sup à 0 car facturation n'est pas au réel":
    'Dit veld moet groter zijn dan 0 omdat facturering niet echt is',
  'Le texte a été validé avec succès': 'De tekst is succesvol gevalideerd',
  Jeux: 'Spelletjes',
  'Voulez-vous vraiment supprimer la ligne de commande pour':
    'Wil je echt de opdrachtregel voor',
  'Ndebele, Nord ; Ndebele Nord': 'Ndebele, Noord; Ndebele Noord',
  'Slave ecclésiastique ; vieux slavon ; slavon ecclésiastique ; vieux bulgare ; vieux slavon ecclésiastique':
    'Kerkelijk Slavisch; Oud Slavisch; Kerkelijk Slavisch; Oud Bulgaars; Oud Kerkelijk Slavisch',
  Swahili: 'Swahili',
  Voyage: 'Reizen',
  'Nombre de mot à ajouter': 'Aantal toe te voegen woorden',
  'Liste des rédacteurs': 'Lijst van schrijvers',
  'le rédacteur': 'de redacteur',
  Kanuri: 'Kanuri',
  rédacteur: 'redacteur',
  Tatar: 'Tataars',
  'Roumain ; Moldave ; Moldovan': 'Roemeens; Moldavisch',
  'Le texte initial de': 'De oorspronkelijke tekst van de',
  'Mail clients': 'Klantenpost',
  'Le contrat de': 'Het contract van',
  'au moins une lettre minuscule et une lettre majuscule,un caractère spécial et un chiffre':
    'ten minste één kleine letter en één hoofdletter, één speciaal teken en één cijfer',
  Transport: 'Transport',
  'Nombre total de mots (existants et ajoutés) :':
    'Totaal aantal woorden (bestaande en toegevoegde) :',
  'Rechercher par mail, prénom, nom, site...':
    'Zoeken op e-mail, voornaam, achternaam, site...',
  'Nombre de mot à ajouter (Min/Max) : ':
    'Aantal toe te voegen woorden (Min/Max) :',
  Compte: 'Account',
  'Tourisme/Loisirs': 'Toerisme/Vrijetijdsbesteding',
  'Nouveau texte': 'Nieuwe tekst',
  Max: 'Max',
  'Kalaallisut ; Groenlandais': 'Kalaallisut; Groenlands',
  'Oups...!il y a une/plusieurs erreur(s) dans la fenêtre du gap sémantique. Veuillez vérifier son contenu pour la/les corriger et soumettre à nouveau votre texte.':
    'Oeps...! Er zijn een of meer fouten in het venster met de semantische kloof. Controleer de inhoud om deze te corrigeren en stuur uw tekst opnieuw in.',
  'ne peut pas être supprimé pour le moment':
    'kan op dit moment niet worden verwijderd',
  'Le texte': 'De tekst',
  URL: 'URL',
  "Un utilisateur existe déjà avec l'email":
    'Er bestaat al een gebruiker met het e-mailadres',
  Cree: 'Cree',
  Prénom: 'Voornaam',
  'commandes prête': 'orders klaar',
  Réinitialiser: 'Reset',
  'Veuillez fournir une date valide': 'Geef een geldige datum',
  'Kuanyama ; Kwanyama': 'Kuanyama; Kwanyama',
  'Luxembourgeois ; Letzeburgesch': 'Luxemburgs; Letzeburgesch',
  Suédois: 'Zweedse',
  'Confirmer le mot de passe': 'Wachtwoord bevestigen',
  'Ce champs est obligatoire et ne peut avoir que des nombres':
    'Dit veld is verplicht en kan alleen getallen bevatten',
  Sciences: 'Wetenschap',
  Tchétchène: 'Tsjetsjeense',
  "est le seul client pour un site, il faut ajouter d'autres pour pouvoir le supprimer":
    'de enige client is voor een site, moeten er anderen worden toegevoegd om hem te verwijderen',
  'Le mot de passe de confirmation ne correspond pas':
    'Bevestigingswachtwoord komt niet overeen',
  Swati: 'Swati',
  Danois: 'Deens',
  Sauvegarder: 'Sla',
  'Veuillez changer les informations suivantes titre et/ou mot clé':
    'Wijzig de volgende informatie: titel en/of trefwoord',
  'importer un document': 'een document importeren',
  Maltais: 'Maltezer',
  'Nb de mots': 'Aantal woorden',
  'Les données fournies sont invalides': 'De verstrekte gegevens zijn ongeldig',
  'Livraison estimée': 'Geschatte levering',
  'Grec moderne (1453-)': 'Modern Grieks (1453-)',
  Avestan: 'Avestaans',
  Inuktitut: 'Inuktitut',
  'Nombre total de mots ajoutés': 'Totaal aantal toegevoegde woorden',
  'le contenu présente des inexactitudes': 'de inhoud bevat onnauwkeurigheden',
  Finnois: 'Finse',
  'Ajouter un admin': 'Een admin toevoegen',
  'Min/Max': 'Min/Max',
  'Modifier le consultant': 'De adviseur wijzigen',
  'Liste des clients': 'Lijst van klanten',
  'Nom client': 'Naam van de klant',
  Vert: 'Groen',
  'Mots clés manquants': 'Ontbrekende sleutelwoorden',
  Lao: 'Lao',
  Somali: 'Somalische',
  'Nb de silo par texte': "Aantal silo's per tekst",
  Italien: 'Italiaans',
  'La commande a été mis à jour avec succès !':
    'De bestelling is succesvol bijgewerkt!',
  Bosniaque: 'Bosnische',
  'Thématiques d\u2019expertise': "Thema's van deskundigheid",
  'Ce mot de passe est le mot de passe que vous avez oublié':
    'Dit is het wachtwoord dat u bent vergeten',
  'a été désactivé avec succès': 'is met succes gedeactiveerd',
  Kongo: 'Kongo',
  'Postuler à la commande': 'Vraag de bestelling aan',
  'mot-clé': 'trefwoord',
  Abkhazien: 'Abchazisch',
  Mongolien: 'Mongools',
  'Typix - Fiche site web': 'Typix - Website',
  'Mail envoyé': 'Verzonden post',
  Géorgien: 'Georgisch',
  'Si des phrases ne sont pas dans un français correct':
    'Als de zinnen niet in correct Frans zijn',
  'En cours': 'In uitvoering',
  voir: 'zie',
  "Date d'ajout": 'Datum toegevoegd',
  'Tarif au mot': 'Tarief per woord',
  Thai: 'Thaise',
  'Détails du texte': 'Details van de tekst',
  'Commandes en retard': 'Late bestellingen',
  disponible: 'beschikbaar',
  Droit: 'Rechts',
  Azerbaïdjanais: 'Azerbeidzjaans',
  'Ajouter un consultant': 'Een adviseur toevoegen',
  'Dans le cadre d\u2019une repasse sur des contenus, seuls les éléments suivants seront pris en charge':
    'Bij het opnieuw afspelen van inhoud worden alleen de volgende items ondersteund',
  'doit comprendre au moins 8 charactères': 'moet ten minste 8 tekens bevatten',
  'Titre de la commande': 'Titel van de bestelling',
  'Langues bihari': 'Bihari talen',
  'Livraison estimé au': 'Geschatte levering door',
  "Le nombre de texte de la commande ne peut pas être inférieur aux nombre de textes attribuées au(x) rédacteur(s). Veuillez d'abord modifier les informations de la ligne de commande":
    'Het aantal teksten in de bestelling kan niet minder zijn dan het aantal teksten dat aan de schrijver(s) is toegewezen. Verander eerst de informatie in de opdrachtregel',
  'Date de livraison': 'Leveringsdatum',
  'Voulez-vous vraiment supprimer le contrat de': 'Wil je echt de',
  'Facturation au réel': 'Feitelijke facturering',
  'Gap sémantique': 'Semantische kloof',
  Estonien: 'Estse',
  Wolof: 'Wolof',
  'Coût d\u2019achat max/mot': 'Maximum aankoopkosten/woord',
  'Détail de la commande': 'Bestelgegevens',
  'Export en cours de téléchargement\u2026': 'Export wordt geupload...',
  'Ce champ est obligatoire et doit être inférieur ou égal au Nombre total des textesde la commande':
    'Dit veld is verplicht en moet kleiner of gelijk zijn aan het Totaal aantal teksten in de bestelling.',
  Arabe: 'Arabisch',
  Bislama: 'Bislama',
  'Mail client': 'Klantenpost',
  '(Titre, mot clé, url, balise, méta-description)':
    '(Titel, sleutelwoorden, url, tag, meta-beschrijving)',
  'Typix - Nouvelle commande': 'Typix - Nieuwe bestelling',
  'Révision en attente': 'Beoordeling in behandeling',
  'Le consultant': 'De adviseur',
  Entreprise: 'Bedrijf',
  Aragonais: 'Aragonese',
  Kashmiri: 'Kashmiri',
  'a été activé': 'is geactiveerd',
  'Interlingua (Association internationale des langues auxiliaires)':
    'Interlingua (Internationale Vereniging van hulptalen)',
  Actualités: 'Nieuws',
  'Votre décision a été prise en compte avec succès':
    'Er is met succes rekening gehouden met uw beslissing',
  Afrikaans: 'Afrikaans',
  'contenu en attente de vérification client':
    'inhoud in afwachting van verificatie door de klant',
  'Fiche du rédacteur': "schrijvers's bestand",
  Outillage: 'Gereedschap',
  'Typix - Détails de la commande': 'Typix - Bestelgegevens',
  'Ajouter ou compléter ci-dessous votre contenu :':
    'Voeg hieronder uw inhoud toe of vul deze aan:',
  Ewe: 'Ooi',
  'contenu en attente de repasse rédacteur':
    'content pending replay schrijvers',
  'La commande a été supprimé avec succès':
    'De bestelling is succesvol verwijderd',
  'Expressions ou phrases françaises mais ne vous convenant pas':
    'Franse uitdrukkingen of zinnen die niet bij je passen',
  Corse: 'Corsica',
  Modifier: 'Bewerk',
  'Nb de GMB': "Aantal GMB's",
  Oromo: 'Oromo',
  Polish: 'Pools',
  'Insérez votre gap sémantique avec l’occurrence':
    'Voeg je semantische gat in met het voorkomen',
  'Nb de textes à optimiser': 'Aantal te optimaliseren teksten',
  Mode: 'Modus',
  Akan: 'Akan',
  'Révisions effectués': 'Gedane herzieningen',
  'Modifier l\u2019admin': 'De admin bewerken',
  'Télécharger le document': 'Het document downloaden',
  Hausa: 'Hausa',
  'Notes rédacteurs': 'Opmerkingen van de schrijvers',
  Quechua: 'Quechua',
  Féroïen: 'Faeröer',
  'Modifier le rédacteur': 'De schrijvers wijzigen',
  Mail: 'Mail',
  Rédacteurs: 'Schrijvers',
  'Typix - Détails du texte': 'Typix - Tekstdetails',
  Hongrois: 'Hongaars',
  'Bon pour livraison': 'Goed voor de levering',
  'Au réel': 'In de echte wereld',
  'Hiri Motu': 'Hiri Motu',
  Hébreu: 'Hebreeuws',
  'Nombre total de mots ajoutés :': 'Totaal aantal toegevoegde woorden :',
  Komi: 'Komi',
  'Doit être inférieur au nombre maximum':
    'Moet kleiner zijn dan het maximumaantal',
  'Nom du texte': 'Naam van de tekst',
  'Ajouter un rédacteur': 'Een redacteur toevoegen',
  Ou: 'Of',
  Utilisateurs: 'Gebruikers',
  Heures: 'Uren',
  'Santé/Bien-être': 'Gezondheid/Welzijn',
  'Interlingue ; Occidental': 'Interlinguaal; Westers',
  'Luba-Katanga': 'Luba-Katanga',
  Letton: 'Lets',
  Anglais: 'Engels',
  Envoyer: 'Stuur',
  'Tableau de bord': 'Dashboard',
  'Demande de révision': 'Verzoek om herziening',
  'Résultat sémantique': 'Semantisch resultaat',
  'Chercher un rédacteur': 'Een redacteur zoeken',
  'Ce champs est obligatoire': 'Dit veld is verplicht',
  Rédaction: 'schrijvers',
  'Modifier le client': 'De cliënt wijzigen',
  'Voulez-vous vraiment supprimer le rédacteur':
    'Wil je echt de schrijvers verwijderen',
  Titre: 'Titel',
  Langue: 'Taal',
  'Les demandes suivantes ne seront pas prises en compte':
    'De volgende aanvragen worden niet in aanmerking genomen',
  'délai dépassé': 'gemiste deadline',
  Tchouvache: 'Tchouvache',
  Ganda: 'Ganda',
  Twi: 'Twi',
  'Contrat déjà existant, veuillez modifier les informations':
    'Bestaand contract, gelieve de informatie te wijzigen',
  Igbo: 'Igbo',
  Yiddish: 'Jiddisch',
  'Limburgan ; Limburger ; Limburgish': 'Limburgan; Limburger; Limburgs',
  'Commandes validées': 'Gevalideerde orders',
  'listeRedacteur-': 'listRedactor-',
  Étape: 'Stap',
  'Energie/Environnement': 'Energie/Milieu',
  Min: 'Min',
  Gujarati: 'Gujarati',
  'ne doit pas inclure votre nom/prénom': 'mag niet uw naam/voornaam bevatten',
  'Typix - Fiche rédacteur': 'Typix - Schrijversbestand',
  'révisions effectuées en attentes de validation':
    'herzieningen in afwachting van validatie',
  'Textes validés': 'Gevalideerde teksten',
  Art: 'Art',
  Dzongkha: 'Dzongkha',
  Polyvalent: 'Veelzijdig',
  Sundanese: 'Sundanees',
  'Nb total de textes': 'Totaal aantal teksten',
  'Nombre de mots gérés': 'Aantal beheerde woorden',
  "L'émail": 'Email',
  'Afficher les résultats': 'Toon resultaten',
  'Frison occidental': 'West-Fries',
  'Modification effectuée avec succès': 'Wijziging succesvol afgerond',
  'Balise titre': 'Titel tag',
  'Typix - Mon profil': 'Typix - Mijn profiel',
  'email invalide': 'ongeldige e-mail',
  'Veuillez ajouter une url afin de pouvoir sauvegarder le texte en brouillon':
    'Voeg een url toe zodat u de tekst als concept kunt opslaan.',
  Macédonien: 'Macedonisch',
  'Votre candidature a bien été envoyée': 'Uw aanvraag is verzonden',
  'E-mail': 'E-mail',
  Fulah: 'Fulah',
  'Ajouter ou compléter ci-dessous votre contenu':
    'Voeg hieronder uw inhoud toe of vul deze aan',
  Manx: 'Manx',
  'Ajout de mots-clés avec la fréquence restante':
    'Trefwoorden toevoegen met resterende frequentie',
  'Fiche du site web': 'Website',
  Contacter: 'Neem contact op met',
  Fidjien: 'Fiji',
  Déconnexion: 'Ontkoppeling',
  email: 'e-mail',
  'Nombre de textes': 'Aantal teksten',
  'Enregistrer et informer client': 'Registreren en informeren van klanten',
  'Date de validation': 'Valideringsdatum',
  'Tonga (Îles Tonga)': 'Tonga (Tonga-eilanden)',
  Javanais: 'Javaanse',
  Portugais: 'Portugees',
  Biélorusse: 'Wit-Russisch',
  'Pour ajouter un nouveau texte': 'Een nieuwe tekst toevoegen',
  'Enfant/Puéri': 'Kind/Puperium',
  'Mots clés': 'Sleutelwoorden',
  Emploi: 'Werkgelegenheid',
  'Voulez-vous vraiment supprimer la commande de': 'Wil je echt de',
  'Mot clé': 'Sleutelwoord',
  Consultants: 'Adviseurs',
  Volapük: 'Volapük',
  Services: 'Diensten',
  'mot-clé (fréquence)': 'trefwoord (frequentie)',
  'Ne plus afficher ce message': 'Dit bericht niet meer weergeven',
  Consultant: 'Consultant',
  "Une erreur s'est produite": 'Er is een fout opgetreden',
  'Avoir au moins 8 caractères avec une lettre majuscule, un chiffre, un charactère spécial':
    'Ten minste 8 tekens met een hoofdletter, een cijfer, een speciaal teken',
  'Pushto ; Pashto': 'Pushto; Pashto',
  Français: 'Frans',
  validées: 'gevalideerd',
  'Url du site': 'Url van de site',
  Précédent: 'Vorige',
  'car celui-ci a déjà rédigé des textes':
    'omdat deze laatste reeds teksten heeft opgesteld',
  'Kikuyu ; Gikuyu': 'Kikuyu; Gikuyu',
  Brouillons: 'Concepten',
  Ido: 'Ido',
  'Contenu disponible': 'Beschikbare inhoud',
  Enseignement: 'Onderwijs',
  'a été livré avec succès': 'is met succes afgeleverd',
  Chinois: 'Chinees',
  Vietnamien: 'Vietnamees',
  'Nouveau client': 'Nieuwe klant',
  'Votre profil a été mis à jour avec succès.':
    'Je profiel is succesvol bijgewerkt.',
  Consignes: 'Instructies',
  'Mot de passe': 'Wachtwoord',
  Annuler: 'Annuleren',
  Non: 'Geen',
  Nom: 'Naam',
  Guarani: 'Guarani',
  "il y'a des commandes liés à au site web":
    'er zijn orders met betrekking tot de website',
  Score: 'Score',
  'Mot de passe mis à jour avec succès': 'Wachtwoord succesvol bijgewerkt',
  Latin: 'Latijn',
  Technologie: 'Technologie',
  Internet: 'Internet',
  Nauru: 'Nauru',
  'a été créé avec succès': 'is met succes aangemaakt',
  Roumain: 'Roemeense',
  Assamais: 'Assamees',
  'Khmer central': 'Centraal Khmer',
  'Navajo ; Navaho': 'Navajo; Navaho',
  'Panjabi ; Punjabi': 'Punjabi; Punjabi',
  'Analyse/Limite': 'Analyse/Limiet',
  Grec: 'Grieks',
  Ojibwa: 'Ojibwa',
  'Mes Projets': 'Mijn projecten',
  'keyword1 (2)\nkeyword2 (1)\nkeyword3 (1)\nkeyword4 (2)\n\u2026':
    'trefwoord1 (2)\ntrefwoord2 (1)\ntrefwoord3 (1)\ntrefwoord4 (2)\n...',
  'ajouter un texte': 'een tekst toevoegen',
  'Détail de la prestation': 'Details van de dienst',
  "Vous avez la possibilité d'exporter le rapport d'une, ou de plusieurs commandes. Pour exporter toutes les commandes d'un client, il vous suffit juste de cliquer sur l'icône de téléchargement en jaune":
    'U hebt de mogelijkheid om het rapport van één of meer bestellingen te exporteren. Om alle bestellingen van een klant te exporteren, hoeft u alleen maar op het gele download-icoon te klikken.',
  'Gestion des utilisateurs': 'Gebruikersbeheer',
  'livré et inférieur au nombre de texte non affecté':
    'geleverd en minder dan het aantal niet-toegewezen teksten',
  'Date deadline validation client': 'Klant validatie deadline',
  Aymara: 'Aymara',
  Validées: 'Gevalideerd',
  Notes: 'Opmerkingen',
  'Nombre de GMB': "Aantal GMB's",
  'résultats sur': 'resultaten op',
  'Prénom / Nom du client': 'Voornaam / Naam van de klant',
  'Tout télécharger': 'Alles downloaden',
  'Champs obligatoires': 'Verplichte velden',
  Éditer: 'Bewerk',
  'Coller le texte initial dans le champs ci-dessous':
    'Plak de oorspronkelijke tekst in het onderstaande veld',
  'ID rédacteur': 'schrijvers ID',
  Arménien: 'Armeens',
  'Grande distribution': 'Grootschalige distributie',
  Welsh: 'Welsh',
  Herero: 'Herero',
  'Enrichissement sémantique': 'Semantische verrijking',
  'Détail de la prestation du contenu': 'Details van de levering van inhoud',
  Noir: 'Zwart',
  'Ajouter un texte': 'Een tekst toevoegen',
  Traduction: 'Vertaling',
  'Immo/Defisc': 'Eigendom/Belasting',
  'Brief détaillé': 'Gedetailleerd overzicht',
  'Séparez les mots-clés par un Enter .':
    'Scheid de trefwoorden met een Enter .',
  Prix: 'Prijzen',
  'mot de passe oublié': 'Wachtwoord vergeten',
  'Ndebele, South ; South Ndebele': 'Ndebele, Zuid; Zuid-Ndebele',
  'Demander une révision': 'Een beoordeling aanvragen',
  'Demander une repasse globale': 'Vraag om een algehele herziening',
  'Sotho, Southern': 'Sotho, Zuidelijk',
  'Le titre de la commande existe déjà':
    'De titel van de bestelling bestaat al',
  'Félicitations !': 'Gefeliciteerd!',
  Kurde: 'Koerdisch',
  Adresse: 'Adres',
  Espagnol: 'Spaans',
  Ndonga: 'Ndonga',
  'En retard': 'Laat',
  'a été ajouté avec succès': 'is met succes toegevoegd',
  Commandes: 'bestellingen',
  'a été mis en brouillon': 'is opgesteld',
  'Rédacteur attribué': 'Toegewezen redacteur',
  Rechercher: 'Zoek op',
  'Nouvelle commande': 'Nieuwe bestelling',
  'Commandes non attribuées': 'Niet toegewezen orders',
  'Le texte a été mis en brouillon': 'De tekst is opgesteld',
  'Contact edito': 'Contact edito',
  Langues: 'Talen',
  Orange: 'Oranje',
  'Nynorsk norvégien': 'Noors Nynorsk',
  Shona: 'Shona',
  Turkmène: 'Turkmenen',
  'contenu repassé, en attente validation client':
    'gestreken inhoud, in afwachting van validatie door de klant',
  'Nombre de mots rédigés': 'Aantal geschreven woorden',
  Malay: 'Maleis',
  'Nombre de Silo': "Aantal silo's",
  Oui: 'Ja',
  Automobile: 'Automotive',
  Résultats: 'Resultaten',
  Afar: 'Afar',
  'Tâche - id tâche': 'Taak - taak-id',
  'Ce champ est obligatoire doit être supérieur à 0':
    'Dit veld is verplicht en moet groter zijn dan 0.',
  'Vous êtes sûr': 'Weet je zeker dat',
  'Réinitialiser votre mot de passe': 'Wachtwoord opnieuw instellen',
  Sindhi: 'Sindhi',
  Bengali: 'Bengaals',
  'Bokmål, norvégien ; Bokmål norvégien': 'Bokmål, Noors; Noors Bokmål',
  'Nombre de Jours': 'Aantal dagen',
  'Min/Max mots': 'Min/Max woorden',
  Slovène: 'Sloveense',
  Site: 'Website',
  'Sinhala ; Cingalais': 'Sinhala; Singalees',
  Bulgare: 'Bulgaarse',
  'Liste des commandes': 'Lijst van bestellingen',
  "L'utilisateur": 'De gebruiker',
  Uzbek: 'Oezbeekse',
  'Titre du texte': 'Titel van de tekst',
  Postuler: 'Solliciteer bij',
  'Nb de textes par Silo': 'Aantal teksten per silo',
  'Nombre total de mots (existants et ajoutés)':
    'Totaal aantal woorden (bestaande en toegevoegde)',
  'Max.': 'Max.',
  Beauté: 'Schoonheid',
  Humanitaire: 'Humanitair',
  Telugu: 'Telugu',
  'Recherche par rédacteur ou texte': 'Zoeken op auteur of tekst',
  'Balise meta-description': 'Meta description tag',
  Malgache: 'Malagasy',
  Tagalog: 'Tagalog',
  'Ce champs doit être sup à 0 et inférieur à 1':
    'Dit veld moet groter zijn dan 0 en kleiner dan 1.',
  'Le rédacteur': 'De redacteur',
  'a été mis à jour avec succès': 'is met succes bijgewerkt',
  'Avoir au moins 8 caractères avec une lettre majuscule, un chiffre, un symbole et ne pas être identique au nom.':
    'Moet minstens 8 tekens lang zijn met een hoofdletter, een cijfer, een symbool en niet identiek aan de naam.',
  'textes en plus': 'meer teksten',
  'Format souhaité': 'Gewenst formaat',
  Chamorro: 'Chamorro',
  Malayalam: 'Malayalam',
  'Détail ligne de commande': 'Bestelregel detail',
  'Veuillez préciser la date': 'Geef de datum aan',
  Pali: 'Pali',
  Clients: 'Klanten',
  'Total facturé': 'Totaal gefactureerd',
  'contenu validé par le client': 'door de klant gevalideerde inhoud',
  'Occitan (post 1500)': 'Occitaans (na 1500)',
  Japonais: 'Japanse',
  Avaric: 'Avaric',
  'Voulez-vous vraiment activer': 'Wil je echt',
  Sanskrit: 'Sanskriet',
  'Toutes les notifications': 'Alle kennisgevingen',
  Marathi: 'Marathi',
  Persan: 'Perzisch',
  'La commande pour le client': 'De bestelling voor de klant',
  'Intitulé de la commande': 'Titel van de bestelling',
  Samoan: 'Samoan',
  Autres: 'Andere',
  Sport: 'Sport',
  "il y'a des commandes liés au site web ":
    'er zijn orders met betrekking tot de website',
  'Ajout de mots-clé avec la fréquence restante':
    'Trefwoorden toevoegen met resterende frequentie',
  'a été supprimé avec succès': 'is met succes verwijderd',
  Postulé: 'Geplaatst op',
  Literie: 'Beddengoed',
  'Édité par le client': 'Bewerkt door de klant',
  Cornouailles: 'Cornwall',
  Tigrinya: 'Tigrinya',
  Textes: 'Teksten',
  'Soumettre un nouveau texte': 'Een nieuwe tekst indienen',
  Téléphone: 'Telefoon',
  Deadline: 'Deadline',
  "Une erreur s'est produite. Veuillez vérifier votre saisie ou essayer plus tard.":
    'Er is een fout opgetreden. Controleer uw invoer of probeer het later opnieuw.',
  Marshallais: 'Marshall',
  "La demande d'ajout de crédit est envoyée":
    'Het verzoek om krediet toe te voegen wordt verzonden',
  'Le rédacteur ': 'De redacteur',
  'Demander des crédits': 'Krediet aanvragen',
  "Cette commande n'existe pas": 'Dit commando bestaat niet',
  Inupiaq: 'Inupiaq',
  Tahitien: 'Tahitiaanse',
  Admins: 'Admins',
  'Mettez des mots-clés avec fréquence': 'Trefwoorden met frequentie instellen',
  Notifications: 'Meldingen',
  'en retard': 'laat',
  "l'admin": 'de beheerder',
  'Mail rédacteurs': 'Mail schrijvers',
  Amharique: 'Amhaars',
  Societe: 'Bedrijf',
  Tsonga: 'Tsonga',
  'Nombre de textes ajoutés': 'Aantal toegevoegde teksten',
  Société: 'Bedrijf',
  Yoruba: 'Yoruba',
  'Le texte a été livré avec succès': 'De tekst werd met succes afgeleverd',
  'Mettez votre texte': 'Zet uw tekst',
  "Oups....! Une erreur s'est produite": 'Oeps....! Er is een fout opgetreden',
  'Prénom/Nom': 'Voornaam/achternaam',
  'Max doit être sup à Min': 'Max moet groter zijn dan Min',
  'Importer un autre document': 'Een ander document importeren',
  'Votre demande a expirée .. veuillez refaire une autre':
    'Uw aanvraag is verlopen ... gelieve een nieuwe te maken',
  'Veuillez corriger le format de votre gap sémantique afin de pouvoir sauvegarder le texte en brouillon':
    'Gelieve het formaat van uw semantische kloof te corrigeren om de tekst als ontwerp op te slaan',
  Exemple: 'Voorbeeld',
  Slovaque: 'Slowaaks',
  Finance: 'Financiën',
  Réactiver: 'Reactiveren',
  'Nb textes': 'Aantal teksten',
  'Intitulé commande': 'Titel van de bestelling',
  Supprimer: 'Verwijder',
  Brouillon: 'Ontwerp',
  'Mots clés restants': 'Resterende trefwoorden',
  Date: 'Datum',
  Rôle: 'Rol',
  'Ce champs doit être sup à 0': 'Dit veld moet groter zijn dan 0',
  'Maison/Déco': 'Huis/decoratie',
  'Vous avez': 'Je hebt',
  'Cette ligne de commande ne peut pas être supprimée car une partie de ses textes a été livré':
    'Deze opdrachtregel kan niet worden verwijderd omdat een deel van de tekst ervan is afgeleverd',
  'vérifiez votre email et cliquez sur le lien pour continuer !':
    'controleer uw e-mail en klik op de link om verder te gaan!',
  Sarde: 'Sardinië',
  'Note rédacteur': 'Noot van de schrijvers',
  'Uighur ; Uyghur': 'Oeigoer; Oeigoer',
  Name: 'naam',
  'Commandes intelligentes': 'Smart opdrachten',
  'Commandes avec révision': 'Smart + review opdrachten',
  'Type de contenu': 'Type inhoud',
  'Fiche produit': 'Productblad',
  GMB: 'GMB',
  'STORE LOCATOR': 'STORE LOCATOR',
  'Rédaction premium': 'Premium redactie',
  'Rédaction avec révision': 'Smart + review redactie',
  'Rédaction intelligente': 'Smart redactie',
  PREMIUM: 'PREMIUM',
  Type: 'Type',
  Editer: 'Bewerken',
  'Tous les types': 'Alle typen',
  Smart: 'Smart',
  'Smart + review': 'Smart + review',
  'Factures traitées': 'Facturen verwerkt',
  'Factures à valider': 'Te valideren facturen',
  'Impossible de générer la facture ! Veuillez réessayer':
    'Kan de factuur niet genereren! Probeer het opnieuw',
  'Récapitulatif de facturation': 'Factuur overzicht',
  'Demander une modification': 'Verzoek tot wijziging',
  'Valider et envoyer la facture': 'Factuur valideren en verzenden',
  'Demande de modification': 'Verzoek tot wijziging',
  'La facture a été validé avec succès!':
    'De factuur is succesvol gevalideerd!',
  "Oups un erreur c'est produit!": 'Oeps, er is een fout opgetreden!',
  'Nombre de texte': 'Aantal teksten',
  'Nombre de mot par texte :': 'Aantal woorden per tekst:',
  Paiement: 'Betaling',
  Virement: 'Overschrijving',
  Délai: 'Termijn',
  'Référence de votre facture': 'Uw factuurreferentie',
  'Coût au mot': 'Kosten per woord',
  'Montant global de la commande': 'Totale bedrag van de bestelling',
  'Votre facture': 'Uw factuur',
  'Importer votre facture': 'Importeer uw factuur',
  'Pas de fichier disponible': 'Geen bestand beschikbaar',
  Télécharger: 'Downloaden',
  Relancer: 'Opnieuw verzenden',
  'Générer la facture': 'Genereer de factuur',
  Payée: 'Betaald',
  'En cours de paiement': 'In afwachting van betaling',
  'En cours de validation': 'In afwachting van validatie',
  'A envoyer': 'Te verzenden',
  'Modification demandée': 'Gevraagde wijziging',
  'Référence de facture est obligatoire': 'Factuurreferentie is verplicht',
  'Le coût au mot doit être un nombre':
    'De kosten per woord moet een getal zijn',
  'Le coût au mot doit être un nombre positif':
    'De kosten per woord moet een positief getal zijn',
  'Le coût au mot est obligatoire': 'De kosten per woord is verplicht',
  'Le montant global de la commande doit être un nombre':
    'Het totale bedrag van de bestelling moet een getal zijn',
  'Le montant global de la commande doit être un nombre positif':
    'Het totale bedrag van de bestelling moet een positief getal zijn',
  'Le montant global de la commande est obligatoire':
    'Het totale bedrag van de bestelling is verplicht',
  'Bill reference existe déja , veuillez réessayer':
    'Factuurreferentie bestaat al, probeer het opnieuw',
  'La facture a été envoyée avec succès!': 'De factuur is succesvol verzonden!',
  'Montant estimé': 'Geschat bedrag',
  Action: 'Actie',
  Facture: 'Factuur',
  Statut: 'Status',
  Factures: 'Facturen',
  'Valider la facture': 'Valideer de factuur',
  'La relance a été envoyée avec succès !':
    'De herinnering is succesvol verzonden!',
  'La demande de modification a été envoyée avec succès !':
    'Het wijzigingsverzoek is succesvol verzonden!',
  'Le cout est trop élevé': 'De kosten zijn te hoog',
  'Le montant global de la commande est trop élevé ':
    'Het totale bedrag van de bestelling is te hoog',
  jours: 'dagen',
  'Factures à envoyer': 'Facturen om te verzenden',
  'Valider le paiement': 'Betalingsvalidatie',
  'Générer une facture': 'Factuur genereren',
  'Montant rédacteur': 'Bedrag voor schrijver',
  'Montant estimé par Typix': 'Geschat bedrag door Typix',
  'Voir la modification': 'Bekijk wijziging',

  'Tag de Titre': 'Titel Tag',
  'Meta description': 'Meta-omschrijving',
  'Nom du produit': 'Productnaam',
  Avantages: 'Voordelen',
  'Description détaillée': 'Gedetailleerde beschrijving',
  'En cours de modification': 'In bewerking',
  'Mes Factures': 'Mijn facturen',
  'En attente de validation': 'In afwachting van validatie',
  'les valeurs négatives ne sont pas autorisées':
    'Negatieve waarden zijn niet toegestaan.',
  'Texte Seulement': 'Alleen tekst',
  'Traduction Seulement': 'Alleen vertaling',
  'La relance peut être faite 20 jours après la soumissions de la facture':
    'De herinnering kan 20 dagen na factuurindiening worden verstuurd',
  Instructions: 'Instructies',
  'Votre avis pour la commande': 'Uw feedback voor de bestelling',
  'Votre évaluation est précieuse pour nous ! Merci !':
    'Uw evaluatie is waardevol voor ons! Bedankt!',
  "Une erreur s'est produite lors de la soumission de votre évaluation. Veuillez réessayer ultérieurement!":
    'Er is een fout opgetreden bij het indienen van uw evaluatie. Probeer het later opnieuw!',
  Evaluer: 'Evalueren',
  Commentaire: 'Opmerking',
  'Votre commantaire': 'Uw opmerking',
  Note: 'Beoordeling',
  'Votre retour est précieux pour nous et nous aide à améliorer nos services.':
    'Uw feedback is waardevol voor ons en helpt ons onze diensten te verbeteren.',
  'Verifier la facture': 'Controleer de factuur',

  ' Votre retour est précieux pour nous et nous aide à améliorer nos services. Merci de partager votre évaluation avec nous!':
    'Uw feedback is waardevol voor ons en helpt ons onze diensten te verbeteren. Bedankt dat u uw evaluatie met ons deelt!',
  'Notes rédacteur': 'Schrijversnotities',
  'Avis client': 'Klantbeoordeling',
  'Pas de commantaire': 'Geen opmerkingen',
  "Qu'avez vous pensé de votre commande?": 'Wat vond u van uw bestelling?',
  'Evaluation de la commande': 'Bestellingsbeoordeling',
  'Rédiger un commentaire': 'Een opmerking schrijven',
  'Contribuez à nous permettre de vous proposer les services de rédaction de la plus haute qualité en partageant vos commentaires.':
    'Help ons u diensten van de hoogste kwaliteit aan te bieden door uw opmerkingen te delen.',
  'Que pouvons-nous améliorer?': 'Wat kunnen we verbeteren?',
  Continuer: 'Doorgaan',
  'Le dernier texte a été validé avec succès':
    'De laatste tekst is succesvol gevalideerd',
  'Rechercher par rédacteur, commandes, et montant':
    'Zoeken op schrijver, bestellingen en bedrag',
  obligatoire: 'verplicht',
  'Note admin': 'Notitie beheerder',
  'Note client': 'Notitie klant',
  Partie: 'Deel',
  'Vous venez de valider tous les contenus rédigés par ':
    'Je hebt zojuist alle inhoud goedgekeurd die is geschreven door ',
  "Qu'en avez vous pensé": 'Wat vond je ervan',
  'La facture a été générée avec succès !':
    'De factuur is succesvol gegenereerd!',
  'La taille du titre et/ou la méta-description est trop courte':
    'De lengte van de titel en/of de meta-omschrijving is te kort',
  'Demande de révision globale': 'Vereisen een globale herziening',
  Valider: 'Valideren',
  'Obligatoire en cas d’optimisation ou traduction':
    'Vereist in geval van optimalisatie of vertaling',
  'Mots clés Bourrées': 'Keyword stuffing',
  'Votre commentaire...': 'Uw opmerking...',
  'Ex : "Contenus de très bonne qualité':
    'Bijv.: "Zeer goede kwaliteit inhoud"',
  "pouvez-vous s'il vous plaît reprendre ce/tte rédacteur/rice pour les prochaines commandes?":
    'Kunt u alstublieft deze schrijver toewijzen voor toekomstige bestellingen?',
  'Ce bouton est pour informer le client que le texte initial, contenait déjà du keyword stuffing':
    'Deze knop is om de klant te informeren dat de oorspronkelijke tekst al trefwoordvulling bevatte',
  'Maillage Interne': 'Internal link',
  'Modifier le texte': 'Bewerk de tekst',
  Ajouter: 'Toevoegen',
  'Demande examen': 'Aanvraag examen',
  'Recherche de mots clés à haute densité': 'Zoeken naar keyword stuffing',
  'Oups, il semblerait qu’il y ait du keyword stuffing dans votre texte : ':
    'Oeps, het lijkt erop dat er keyword stuffing in uw tekst staat: ',
  'Oups, il semblerait qu’il y ait du keyword stuffing (trop d’occurrences d’un ou plusieurs mots clés) dans le texte initial.':
    'Oeps, het lijkt erop dat er keyword stuffing (te veel voorkomens van één of meer zoekwoorden) is in de oorspronkelijke tekst.',
  'Merci de vous assurer que la densité des mots clés soit optimisée pour le SEO (une occurrence maximum tous les 50 mots).':
    'Gelieve ervoor te zorgen dat de zoekwoorddichtheid is geoptimaliseerd voor SEO (maximaal één keer per 50 woorden).',
  'Pour cela merci de ne pas retoucher le texte existant et de bien vouloir envoyer une demande d’examen au support.':
    'Voor dit doel, bewerk de bestaande tekst alstublieft niet en stuur vriendelijk een verzoek om een onderzoek naar de ondersteuning.',
  'Votre demande a été bien envoyée !': 'Uw verzoek is succesvol verzonden!',
  "Il y a eu un problème lors de l'envoi de votre demande":
    'Er is een probleem opgetreden bij het verzenden van uw verzoek.',
  'Veuillez attendez pour le  keyword Stuffing analyse':
    'Wacht alstublieft op de keyword stuffing-analyse.',
  'Inserez le maillage interne': 'Voeg het interne koppelingsschema in',
  'Merci de vous assurer que la densité des mots clés soit optimisée pour le SEO (une occurrence maximum tous les 50 mots).\nSi vous constatez un terme pouvant avoir plusieurs significations (Exemple : Former / Formation/ Forme ou Matelas/Matelassé) , vous pouvez faire une demande d’examen auprès du support.':
    'Zorg ervoor dat de trefwoorddichtheid is geoptimaliseerd voor SEO (maximaal één keer per 50 woorden).\nAls u een term tegenkomt die meerdere betekenissen kan hebben (Voorbeeld: Former / Formation / Form of Matelas / Matelassé), kunt u een beoordeling aanvragen bij de ondersteuning.',
  'Mots clés à haute densité dans le texte actuel':
    'Trefwoorden met hoge dichtheid in de huidige tekst',
  'Mots clés à haute densité dans le texte initial':
    'Trefwoorden met hoge dichtheid in de oorspronkelijke tekst',
  'Texte en cours de rédaction !': 'Tekst in bewerking !',
  'Êtes-vous sûr(e) de vouloir valider le texte ? Assurez-vous d’abord d’avoir enregistré les modifications.':
    'Er du sikker på, at du vil bekræfte teksten? Sørg først for, at du har gemt ændringerne.',
  "Information dernière minute ! Ton stock de crédits sera bientôt épuisé :( Pour anticiper, n'hésite pas à demander dès maintenant plus de crédits pour terminer ta commande.":
    'Laatste minuut informatie! Je tegoed aan credits raakt binnenkort op :( Om vooruit te lopen, aarzel niet om nu al meer credits aan te vragen om je bestelling te voltooien.',
  'Voulez-vous confirmer l’URL actuelle ou la modifier ?':
    'Wilt u de huidige URL bevestigen of wijzigen?',
  'Veuillez fournir une URL valide': 'Gelieve een geldige URL op te geven.',
  'Merci de bien vouloir indiquer ci-dessous l’url de la page où a été intégré le contenu:':
    "Venligst angiv URL'en til siden, hvor indholdet blev integreret:",
  'Contenu en ligne': 'Online inhoud',
  'Télécharger le document de révision': 'Het herzieningsdocument downloaden',
  'Date d’envoi': 'Verzenddatum',
  Information: 'Informatie',
  Enregistrer: 'Opslaan',
  'Textes en ligne': 'Teksten online',
  'Livrer les textes': 'Lever de teksten',
  Indisponible: 'Niet beschikbaar',
  Disponible: 'Beschikbaar',
  'Les textes ont été livrés avec succès.':
    'De teksten zijn succesvol geleverd.',
  'Le texte a été livré avec succès.': 'De tekst is succesvol geleverd.',
  'Les textes ont été validés avec succès.':
    'De teksten zijn succesvol gevalideerd.',
  'Voulez-vous vraiment valider les Textes de la commande':
    'Wilt u echt de teksten van de bestelling valideren?',
  'Voulez-vous vraiment livrer les Textes de la commande':
    'Wilt u echt de teksten van de bestelling leveren?',
  'Fiche produit longue': 'Lange productfiche',
  'Fiche produit courte': 'Korte productfiche',
  'Un texte est trop long et ne peut pas être exporté sur Excel':
    'Een tekst is te lang en kan niet naar Excel worden geëxporteerd.',
  'Mettre un texte en brouillon en livré':
    'Een tekst van concept naar geleverd veranderen',
  'Remettre un texte validé à livré':
    'Een gevalideerde tekst naar geleverd veranderen',
  'Invalider le texte': 'De tekst ongeldig maken',
  'Je souhaiterai modifier mon mot de passe : comment faire ?':
    'Jeg vil gerne ændre min adgangskode: hvordan gør jeg det?',
  'Comment mettre un contenu en bon pour livraison ?':
    'Hoe stel ik inhoud in voor levering?',
  'Je ne peux pas mettre mon contenu en « brouillon »':
    'Ik kan mijn inhoud niet als "concept" opslaan',
  'Typix n’a pas enregistré mes dernières modifications':
    'Typix heeft mijn laatste wijzigingen niet opgeslagen',
  'Comment rédiger une création de contenu ?': 'Hoe schrijf je contentcreatie?',
  'Comment rédiger une optimisation de contenu ?':
    'Hoe schrijf je contentoptimalisatie?',
  'Je ne vois plus ma commande – que faire ?':
    'Ik zie mijn bestelling niet meer – wat moet ik doen?',
  'Comment générer une facture ?': 'Hoe genereer je een factuur?',
  'Je ne peux pas generer ma facture : que faire ?':
    'Ik kan mijn factuur niet genereren: wat moet ik doen?',
  'Tuto process Typix global': 'Globaal Typix-proces - tutorial',
  'Tuto mise en ligne des contenus': 'Hoe inhoud uploaden - tutorial',
  'Modification mot de passe': 'Wachtwoord wijzigen',
  'Le test ne me convient pas': 'De test bevalt me niet',
  'Comment valider un contenu dans Typix ?': 'Hoe valideer je inhoud in Typix?',
  'Tuto Facturation': 'Facturatiehandleiding',
  'Le statut du contenu a bien été modifié':
    'De status van de inhoud is succesvol gewijzigd',
  'Le gap sémantique de ce mot clé n’a pas encore été validé, veuillez contacter le support Typix : support-typix@pixalione.com':
    'De semantische kloof van dit zoekwoord is nog niet gevalideerd, neem contact op met Typix ondersteuning: support-typix@pixalione.com',
  'Ce mot clé n’existe pas sur MONETORING, veuillez vérifier avec le support Typix : support-typix@pixalione.com':
    'Dit trefwoord bestaat niet op MONETORING, controleer alstublieft met Typix-ondersteuning: support-typix@pixalione.com',
  'Ce mot clé n’existe pas sur MONETORING, veuillez vérifier avec le support Typix : support-typix@pixalione.com':
    'Questa parola chiave non esiste su MONETORING, verifica con il supporto Typix: support-typix@pixalione.com',
  'Récupérer le Gap': 'Het gat ophalen',
  'Le statut du contenu a bien été modifié':
    'De status van de inhoud is succesvol gewijzigd',
  'Le gap sémantique de ce mot clé n’a pas encore été validé, veuillez contacter le support Typix : support-typix@pixalione.com':
    'De semantische kloof van dit zoekwoord is nog niet gevalideerd, neem contact op met Typix ondersteuning: support-typix@pixalione.com',
  'Ce mot clé n’existe pas sur MONETORING, veuillez vérifier avec le support Typix : support-typix@pixalione.com':
    'Dit trefwoord bestaat niet op MONETORING, controleer alstublieft met Typix-ondersteuning: support-typix@pixalione.com',
  'Ce mot clé n’existe pas sur MONETORING, veuillez vérifier avec le support Typix : support-typix@pixalione.com':
    'Questa parola chiave non esiste su MONETORING, verifica con il supporto Typix: support-typix@pixalione.com',
  'Récupérer le Gap': 'Het gat ophalen',
  'Traduction premium': 'Premium vertaling',
  'Rédaction et/ou Traduction intelligente': 'Slim schrijven en/of vertaling',
  'Rédaction et/ou Traduction premium': 'Premium schrijven en/of vertaling',
  'Rédaction et/ou Traduction avec révision':
    'Schrijven en/of vertaling met herziening',
  'Rédaction et/ou Traduction intelligente': 'Slim schrijven en/of vertaling',
  'Traduction avec révision': 'Vertaling met herziening',
  'Traduction intelligente': 'Slimme vertaling',
  'Le nombre de mots commandé est supérieur à celui vendu':
    'Het aantal bestelde woorden is groter dan het verkochte',
  'Rédaction et/ou Traduction premium': 'Premium schrijven en/of vertaling',
  'Rédaction et/ou Traduction smart + review':
    'Slim schrijven en/of vertaling + herziening',
  'Rédaction et/ou Traduction smart': 'Slim schrijven en/of vertaling',
  'Nom Silo': 'Naam Silo',
  'Remettre en brouillon': 'Terugzetten in concept',
  'Bon pour Livraison Vérifié': 'Geverifieerd voor levering',
  'Voulez-vous vraiment remettre en brouillon les Textes de la commande':
    'Wilt u de teksten van de bestelling echt terugzetten in concept',
  'La vérification du texte a été annulée.':
    'De tekstverificatie is geannuleerd.',
  'Voulez-vous vraiment annuler la vérification du texte?':
    'Wilt u de tekstverificatie echt annuleren?',
  'Etes-vous sûr(e) de vouloir regénérer tous les contenus ?':
    'Weet u zeker dat u alle inhoud opnieuw wilt genereren?',
  'à cocher si la commande a l’intention d’avoir un rédacteur exclusif pour le client':
    'aanvinken als de bestelling een exclusieve schrijver voor de klant wil hebben',
  Gouvernance: 'Bestuur',
  'Modification à valider': 'Wijziging ter goedkeuring',
  Rédacteur: 'Redacteur',
  'Nouveau site web': 'Nieuwe website',
  'Mail Chef Project': 'Projectmanager e-mail',
  'Site web': 'Website',
  'Liste des siteweb': 'Website lijst',
  'Projets non attribuées': 'Niet-toegewezen projecten',
  'Projets en cours': 'Lopende projecten',
  'Projets en retard': 'Achterstallige projecten',
  'Projets validées': 'Geverifieerde projecten',
  'Projets smart + reviews': 'Smart + review projecten',
  'Projets smart': 'Smart projecten',
  'Ajouter un siteweb': 'Een website toevoegen',
  'Nouveau projet': 'Nieuw project',
  'Comparaison du score global': 'Comparison of global score',
  'avec le top 3 concurrents': 'with top 3 competitors',
  'Position du mot clé avec le top 3 concurrents': 'Keyword ranking',
  Balises: 'Tags',
  Lisibilité: 'Leesbaarheid',
  'Longueur des paragraphes': 'Paragraaflengte',
  Phrases: 'Zinnen',
  'de +100 mots sur': 'meer dan +100 woorden in',
  Phrase: 'Zin',
  'de +20 mots sur': 'meer dan +20 woorden in',
  'Notre recommandation': 'Onze aanbeveling',
  'Longueur du texte': 'Tekstlengte',
  'Formats de contenus variés': 'Diverse inhoudsformaten',
  'par rapport au top 3 de vos concurrents':
    'in vergelijking met de top 3 van je concurrenten',
  'Vous êtes': 'U bent',
  'Vous avez un score global de': 'U heeft een totaalscore van',
  'pour une moyenne du secteur à': 'voor een gemiddelde van de sector van',
  'GAP comblé - Mission accomplie': 'Kloof gedicht – Missie voltooid',
  'Mots clé restants': 'Resterende trefwoorden',
  'Phrases de +20 mots': 'Zinnen van meer dan 20 woorden',
  'Titre H1': 'H1-titel',
  'Titres H2': 'H2-titels',
  'Dans le texte actuel': 'In de huidige tekst',
  'Dans le texte initial': 'In de oorspronkelijke tekst',
  mots: 'woorden',
  objectif: 'doel',
  phrase: 'zin',
  paragraphe: 'paragraaf',
  'Temps de lecture': 'Leestijd',
  'requis ( Bullet point, Bon à savoir,Sommaire)':
    'vereist (opsommingstekens, goed om te weten, samenvatting)',
  'de contenu sur': 'hoeveelheid inhoud in',
  'Félicitations ! Le nombre de mots correspond à la quantité d’informations importantes permettant de répondre au sujet':
    'Gefeliciteerd! Het aantal woorden komt overeen met de hoeveelheid belangrijke informatie om het onderwerp te behandelen.',
  'Félicitations ! Votre contenu ne contient aucune phrase de plus de 20 mots !':
    'Gefeliciteerd! Uw inhoud bevat geen enkele zin van meer dan 20 woorden!',
  'Félicitations ! Votre contenu est aéré et facilite la lecture':
    'Gefeliciteerd! Uw inhoud is goed gestructureerd en vergemakkelijkt het lezen.',
  'Félicitations ! Votre contenu dispose de formats variés qui dynamisent la lecture et permettent d’isoler les informations importantes.':
    'Gefeliciteerd! Uw inhoud maakt gebruik van diverse formaten die het lezen dynamischer maken en belangrijke informatie benadrukken.',
  'Félicitations ! Le contenu présente une balise h1 unique et contient le mot clé à l’origine du texte':
    'Gefeliciteerd! De inhoud bevat een unieke H1-tag en bevat het oorspronkelijke trefwoord.',
  'Félicitations ! Le contenu est structuré de façon cohérente et présente au moins 2 balises <h2>':
    'Gefeliciteerd! De inhoud is coherent gestructureerd en bevat minimaal twee <h2>-tags.',
  'Félicitations ! Votre contenu contient du maillage interne pondéré et qui ne pollue pas la lecture.':
    'Gefeliciteerd! Uw inhoud bevat gebalanceerde interne links die de leesbaarheid niet verstoren.',
  'Félicitations ! Le scoring d’enrichissement est supérieur à 85%!':
    'Gefeliciteerd! De verrijkingsscore is hoger dan 85%!',
  'Félicitations ! Votre texte n’est pas suroptimisé sur le mot clé ciblé.':
    'Gefeliciteerd! Uw tekst is niet overgeoptimaliseerd voor het gekozen trefwoord.',
  'Le nombre de mots doit correspondre à la quantité d’informations importantes permettant de répondre au sujet':
    'Het aantal woorden moet overeenkomen met de hoeveelheid belangrijke informatie om het onderwerp te behandelen.',
  'Il est important d’adapter le niveau de vocabulaire en fonction de votre cible. Un vocabulaire simple pourrait l’infantiliser et, à l’inverse, un vocabulaire trop complexe pourrait rendre le contenu inaccessible.':
    'Het is belangrijk het vocabulaire aan te passen aan uw doelgroep. Te eenvoudige woorden infantiliseert, te complexe woorden maken de inhoud ontoegankelijk.',
  'Plus de 70% des internautes ne lisent pas les phrases > 20 mots => Utiliser des phrases concises pour augmenter le temps de rétention sur la page':
    'Meer dan 70% van de internetgebruikers leest geen zinnen van meer dan 20 woorden → Gebruik korte zinnen om de verblijftijd op de pagina te vergroten.',
  "Un contenu constitué de blocs de paragraphes trop compact va altérer l'UX et augmenter le taux de rebond.":
    'Te compacte paragraafblokken schaden de gebruikerservaring en verhogen de bounce rate.',
  "Multipliez les différents formats d'affichage pour une lecture plus lisible et confortable.":
    'Gebruik diverse weergaveformaten voor een duidelijkere en prettigere leeservaring.',
  'Un contenu optimisé doit obligatoirement contenir une seule balise h1 et mentionner le mot clé. ':
    'Geoptimaliseerde inhoud moet exact één H1-tag bevatten en het trefwoord vermelden.',
  'Pour une structure de contenu optimale, il faut au moins 2 balises h2.':
    'Voor een optimale structuur zijn minimaal twee H2-tags vereist.',
  'Le maillage interne est un très bon moyen de connecter une page avec d’autres pages traitant du même sujet, ou complémentaires.':
    'Interne linking is een uitstekende manier om een pagina te verbinden met andere gerelateerde of aanvullende pagina’s.',
  'Un contenu optimisé doit obtenir un scoring d’enrichissement de min 85%. Supprimer du gap sémantique altèrera le scoring d’optimisation':
    'Geoptimaliseerde inhoud moet een verrijkingsscore van minimaal 85% behalen. Semantische inhoud verwijderen verlaagt de score.',
  'Répéter le mot trop de fois dans le contenu est pénalisant pour le moteur de recherche. Idéalement, ne pas dépasser un taux de 2.35% (soit environs 2 répétitions pour 100 mots). ':
    'Te vaak een woord herhalen wordt bestraft door zoekmachines. Idealiter niet meer dan 2,35% (ongeveer 2 herhalingen per 100 woorden).',
  'Aucune balise H1 trouvée.': 'Geen H1-tag gevonden.',
  'Balise H1 contient le mot-clé.': 'De H1-tag bevat het trefwoord.',
  'Balise H1 présente mais sans le mot-clé.':
    'De H1-tag is aanwezig maar bevat het trefwoord niet.',
  '{{count_total}} balises H2 trouvées, {{count_with_kw}} avec mot-clé.':
    '{{count_total}} H2-tags gevonden, {{count_with_kw}} met trefwoord.',
  ' balises H2 trouvées,': ' H2-tags gevonden,',
  ' avec mot-clé.': ' met trefwoord.',
  'Très facile à lire : Accessible aux enfants ou à des personnes avec un niveau de lecture basique.':
    'Zeer makkelijk te lezen: toegankelijk voor kinderen of mensen met basisleesniveau.',
  'Facile à lire : Compréhensible par la majorité des adultes et adolescents.':
    'Makkelijk te lezen: begrijpelijk voor de meeste volwassenen en tieners.',
  'Difficile à lire : Nécessite un bon niveau de lecture, parfois un bagage académique':
    'Moeilijk te lezen: vereist goed leesniveau, soms academische achtergrond.',
  'Très difficile à lire : Réservé à un public expert ou très averti':
    'Zeer moeilijk te lezen: voor experts of zeer ervaren lezers.',
  'Wording adapté': 'Geschikte woordkeuze',
  "La balise H1 est essentielle pour l'optimisation SEO.":
    'De H1-tag is essentieel voor SEO-optimalisatie.',
  'Une seule balise H1 avec le mot-clé est recommandée.':
    'Een enkele H1-tag met het trefwoord wordt aanbevolen.',
  'Ajoutez le mot-clé dans la balise H1.':
    'Voeg het trefwoord toe in de H1-tag.',
  'Adaptez votre vocabulaire à votre audience. Trop simple infantilise, trop complexe exclut.':
    'Pas je woordkeuze aan op je doelgroep. Te eenvoudig infantiliseert, te complex sluit uit.',
  'Les contenus web se lisent rapidement. Un temps trop long peut décourager.':
    'Webinhoud wordt snel gelezen. Te lange leestijd kan ontmoedigend zijn.',
  'Information sur la structure': 'Informatie over de structuur',
  'Information sur le résultat sémantique': 'Informatie over het semantische resultaat',
  'Information sur les balises HTML': 'Informatie over HTML-tags',
  'Information sur le keyword stuffing': 'Informatie over keyword stuffing',

  ////////////
  'Derniers contenus rédigés': 'Laatst geschreven inhoud',
  'voir plus': 'Meer bekijken',
  'texte': 'Tekst',
  'date d\'ajout': 'Toevoegdatum',
  'titre du projet': 'Projecttitel',
  'Date de création': 'Aangemaakt op',
  'dernières projets créés': 'Laatst aangemaakte projecten',
  '% projets par statut de validation :': '% projecten per goedkeuringsstatus:',
  'non attribués': 'Niet toegewezen',
  'en cours': 'Bezig',
  'en retard': 'Te laat',
  'validées': 'Goedgekeurd',
  'smart + reviews': 'Smart + Beoordelingen',
  'smart': 'Smart',
  'premium': 'Premium',
  'smart + review': 'Smart + Review',
  'Statut d\'avancement des contenus:': 'Status van inhoudsvoortgang:',
  'Nombre de textes publiés :': 'Aantal gepubliceerde teksten:',
  'Nb de textes publiés': 'Aantal gepubliceerde teksten',
  'Top ranked': 'Top beoordeeld',
  'Mot clé': 'Trefwoord',
  'Clicks': 'Klikken',
  'Clicks (Y-1)': 'Klikken (Y-1)',
  'Position': 'Positie',
  'Sessions': 'Sessies',
  'Sessions (Y-1)': 'Sessies (Y-1)',
  'Evolution performance': 'Prestatieontwikkeling',
  'Pourcentage': 'Percentage',
  'Livré': 'Geleverd',
  'Publié': 'Gepubliceerd',
  'Suivez vos contenus et projets en temps réel': 'Volg je inhoud en projecten in realtime',
  'Tableau de bord': 'Dashboard',
  'Titre du projet': 'Projecttitel',
  'Conversions': 'Conversies',
  'Impressions': 'Vertoningen',
  'Jan': 'Jan',
  'Fév': 'Feb',
  'Mars': 'Mrt',
  'Avr': 'Apr',
  'Mai': 'Mei',
  'Juin': 'Jun',
  'Juil.': 'Jul',
  'Août': 'Aug',
  'Sept': 'Sep',
  'Oct': 'Okt',
  'Nov': 'Nov',
  'Déc': 'Dec',
  'Pour activer cette fonctionnalité, ajoutez notre adresse ': 'Om deze functie te activeren, voeg ons adres toe ',
  'à votre ': ' aan uw ',
  'Search Console': 'Search Console',
  ', ': ', ',
  'puis cliquez ici pour lancer l’analyse.': 'klik daarna hier om de analyse te starten.',
  'all devices': 'alle apparaten',
  'Desktop': 'Desktop',
  'Mobile': 'Mobiel',
  '30 days': '30 dagen',
  '7 days': '7 dagen',
  '90 days': '90 dagen',
  'Aucun projet créé pour le moment.': 'Nog geen projecten aangemaakt.',
  'Lancer votre premier projet': 'Start je eerste project',
  'Aucun contenu disponible pour ce site web.': 'Geen inhoud beschikbaar voor deze website.',
  'Mes contenus': 'Mijn inhoud',
  'Type de contenu': 'Inhoudstype',
  'Date d\'ajout': 'Toevoegdatum',
  'URL': 'URL',
  'Status': 'Status',
  'Date de livraison': 'Leverdatum',
  'Date de validation': 'Goedkeuringsdatum',
  'Date de déploiement': 'Implementatiedatum',
  'Action': 'Actie',
  'Aucun contenu pour ce filtre.': 'Geen inhoud voor dit filter.',
  'Chargement...': 'Laden...',
  'Aucun contenu.': 'Geen inhoud.',
  'Précédent': 'Vorige',
  'Suivant': 'Volgende',
  'fiche produit': 'Productfiche',
  'Page catégorie': 'Categoriëpagina',
  'Fiche GMB': 'GMB-pagina',
  'store locator': 'Winkelzoeker',
  'redaction': 'Redactie',
  'traduction': 'Vertaling',
  'Fiches produit SEO': 'SEO-productfiches',
  'Derniers projets crées': 'Laatst aangemaakte projecten',
  'Agent IA': 'AI-agent',
  'Dérniére mise à jour': 'Laatst bijgewerkt',
  'Créer un nouveau contenu': 'Nieuwe inhoud maken',
  'Rédigez un texte optimisé grâce à l’IA — rapide, pertinent et performant.': 'Schrijf een door AI geoptimaliseerde tekst – snel, relevant en effectief.',
  'Validé': 'Goedgekeurd',
  'En ligne': 'Online',
  'Fiches GMB': 'GMB-pagina’s',
  'Fiches store locator': 'Winkelzoekerpagina’s',
  'Pages catégories': 'Categoriepagina’s',
  'Traduction IA': 'AI-vertaling',
  'Actions': 'Acties',
  'Traduire un nouveau contenu': 'Nieuwe inhoud vertalen',
  'Traduisez vos contenus automatiquement avec une précision multilingue.': 'Vertaal je inhoud automatisch met meertalige precisie.',
  'Nom du projet': 'Projectnaam',
  'Chef de projet': 'Projectmanager',
  'Deadline du projet': 'Projectdeadline',
  'Informations globales': 'Algemene informatie',
  'Contenu du projet': 'Projectinhoud',
  'Séléctionner le type de contenu': 'Selecteer inhoudstype',
  'Sélectionner un agent IA personnalisé': 'Selecteer aangepaste AI-agent',
  'Créer un agent IA personnalisé': 'Maak aangepaste AI-agent',
  'Liens utiles': 'Nuttige links',
  'Rédacteur(s)': 'Redacteur(en)',
  'Deadline': 'Deadline',
  'Nb textes': 'Aantal teksten',
  'IA + Revue par rédacteur': 'AI + Redacteursreview',
  'Ajouter un projet': 'Project toevoegen',
  'Projets': 'Projecten',
  'Non attribués': 'Niet toegewezen',
  'Rédaction IA': 'AI-redactie',
  'Résultats sur': 'Resultaten voor',
  'Êtes-vous sûr de vouloir supprimer cet agent IA ?': 'Weet je zeker dat je deze AI-agent wilt verwijderen?',
  'Mes agents IA': 'Mijn AI-agenten',
  'Tous': 'Alle',
  'Rédaction': 'Redactie',
  'Traduction': 'Vertaling',
  'Rechercher': 'Zoeken',
  'Sélectionner un site': 'Selecteer site',
  'Créer un agent IA personnalisé': 'Maak aangepaste AI-agent',
  'Définissez la mission, le rôle, la langue, le type de contenu et plus encore.': 'Stel missie, rol, taal, inhoudstype en meer in.',
  'Nouvel agent': 'Nieuwe agent',
  'Rôle :': 'Rol:',
  'Type de contenu :': 'Inhoudstype:',
  'Langue :': 'Taal:',
  'Siteweb :': 'Website:',
  'GBP': 'GBP',
  'Sélectionner un LLM': 'Selecteer LLM',
  'Fiche produit smart': 'Slim productfiche',
  'Détails du texte': 'Tekstdetails',
  '(Mot clé*, URL, Balise titre, Balise méta-description)': '(Trefwoord*, URL, Titel, Meta-beschrijving)',
  'URL siteweb*': 'Website-URL*',
  'Balise titre': 'Titel',
  'Balise méta-description': 'Meta-beschrijving',
  'Sélectionner un site web': 'Selecteer website',
  'Sélectionner un agent IA': 'Selecteer AI-agent',
  'Lancer': 'Starten',
  'Relancer': 'Opnieuw starten',
  'Génération en cours...': 'Generatie bezig...',
  'Générer': 'Genereren',
  'Enregistrement...': 'Opslaan...',
  'Enregistrer ': 'Opslaan',
  'Livrer': 'Leveren',
  'Livraison...': 'Bezig met leveren...',
  'En ligne...': 'Online...',
  "Derniers contenus ajoutés": "Laatst toegevoegde inhoud",
  //////

  'Nom de l\'agent': 'Naam van de agent',
  'Site web': 'Website',
  'Mission': 'Missie',
  'Langue de traduction': 'Vertaaltaal',
  'Langue': 'Taal',
  'Tonalité': 'Toon',
  'Cible / Audience': 'Doelgroep',
  'Base de connaissance locale': 'Lokale kennisbasis',
  'Base de connaissance en ligne': 'Online kennisbasis',
  'Sélect. fichiers': 'Selecteer bestanden',
  'Ex: URL1, URL2': 'Bijv.: URL1, URL2',
  'Annuler': 'Annuleren',
  'Mettre à jour': 'Bijwerken',
  'Valider': 'Valideren',
  'Ex: un paragraphe sur les types d\'intervention, un paragraphe sur les avantages':
    'Bijv.: een paragraaf over de soorten interventies, een paragraaf over de voordelen',
  'ex : les parapluies pliant sont à ouverture automatique, les autres sont manuels':
    'Bijv.: opvouwbare paraplu\'s openen automatisch, andere zijn handmatig',
  '📚 Base de connaissances': '📚 Kennisbasis',

  'Type de produits / services proposés par le site*': 'Type producten/diensten aangeboden door de site*',
  'Règles rédactionnelles': 'Redactionele regels',
  'Lexique recommandé': 'Aanbevolen woordenlijst',
  'Expressions interdites': 'Verboden uitdrukkingen',
  'Instructions de personnalisation': 'Aanpassingsinstructies',

  "🧩 Informations générales": "🧩 Algemene informatie",
  "🗣️ Ton & Audience": "🗣️ Toon en doelgroep",
  "📝 Structure & Rédaction": "📝 Structuur en redactie",
  "📚 Base de connaissances": "📚 Kennisbasis",
  "Structure de texte attendu": "Verwachte tekststructuur",
  "Enrichissement SEO": "SEO-optimalisatie",
  "traduction IA": "AI-vertaling",
  "Traduction en cours...": "Vertaling bezig...",
  "Traduire": "Vertalen",
  "Créer votre assistant éditorial sur mesure": "Creëer uw op maat gemaakte redactionele assistent",
  "Votre texte traduit": "Uw vertaalde tekst",
  "Détail du projet": "Projectdetails",
  "Détail d'attribution": "Toewijzingsdetails",
  "Détail des contenus": "Inhoudsdetails",

  "Nom agent": "Naam agent",
  "Rédaction": "Redactie",
  "Traduction": "Vertaling",
  "Mots clé": "Trefwoorden",
  "Url de la page": "Pagina-URL",
  "Entrez le mot clé principal": "Voer het hoofdtrefwoord in",
  "Entrez l url": "Voer de URL in",
  "Date d'ajout": "Toevoegingsdatum",
  "Dernière mise à jour": "Laatste update",
  "URL": "URL",
  "Status": "Status",
  "Actions": "Acties",
  "Détails du texte": "Tekstdetails",
  "Contenus disponibles": "Beschikbare inhoud",
  "Textes générés": "Gegenereerde teksten",

  "Veuillez d'abord sélectionner un site web": "Selecteer eerst een website",
  "Chargement des agents...": "Agents laden...",
  "Aucun agent disponible pour ce site": "Geen agents beschikbaar voor deze site",
  "Sélectionner...": "Selecteren...",
  "Modifier cet agent": "Deze agent bewerken",
  "Créer un agent IA personnalisé": "Een gepersonaliseerde AI-agent creëren",
  "Rédaction en cours...": "Redactie bezig...",
  "Génération en cours": "Generatie bezig",
  "Rédiger un contenu": "Inhoud schrijven",
  "Rédiger un lot de contenus": "Een batch inhoud schrijven",
  "Url page": "Pagina-URL",
  "Entrez l'URL cible de votre contenu (facultatif).": "Voer de doel-URL van uw inhoud in (optioneel).",
  "GAP sémantique": "Semantische kloof",
  "keyword1 (2),\nkeyword2 (1),\nkeyword3 (1),\nkeyword4 (2),\n.....":
    "keyword1 (2),\nkeyword2 (1),\nkeyword3 (1),\nkeyword4 (2),\n.....",
  "Maillage interne": "Interne linking",
  "Introduisez le maillage": "Voer de linking in",
  "Introduisez le maillage interne": "Voer de interne linking in",
  "Importer un fichier contenant la liste des thématiques à rédiger et l'IA fera le reste 😊":
    "Importeer een bestand met de lijst van te schrijven onderwerpen en de AI doet de rest 😊",
  "Importer": "Importeren",
  "Saisissez le mot-clé principal de votre contenu.": "Voer het hoofdtrefwoord van uw inhoud in.",
  "Texte à traduire": "Te vertalen tekst",
  "Saisissez le texte à traduire": "Voer de te vertalen tekst in",
  "Traduire un contenu": "Inhoud vertalen",
  "Traduire un lot de contenus": "Een batch inhoud vertalen",
  "Importer un fichier contenant la liste des textes à traduire et l'IA fera le reste 😊":
    "Importeer een bestand met de lijst van te vertalen teksten en de AI doet de rest 😊",
  "Commencer la traduction": "Vertaling starten",
  "Lancer la traduction": "Vertaling lanceren",
  "Commencer la rédaction": "Redactie starten",
  "Lancer la rédaction": "Redactie lanceren",


  'En ligne...': 'Online...',
  'Ajouter un nouveau site web': 'Nieuwe website toevoegen',
  'Créer': 'Aanmaken',
  'Séléctionner ou ajoutez les thématiques qui reflètent votre expertise.': 'Selecteer of voeg thema’s toe die uw expertise weerspiegelen.',
  'Ajoutez ou sélectionnez une thématique': 'Voeg een thema toe of selecteer er een.',
  'Le site web a été créé avec succès': 'De website is succesvol aangemaakt',
  'Nous configurons actuellement vos agents IA. Ils seront bientôt prêts à vous assister dans la génération de vos contenus.': 'We configureren momenteel uw AI-agenten. Ze zullen binnenkort klaar zijn om u te helpen met het genereren van uw content.',
  'Derniers contenus ajoutés': 'Laatst toegevoegde content',
  'Tous les sites': 'Alle websites',
  'Sélectionner le site web': 'Website selecteren',
  'Aucun fichier sélectionné': 'Geen bestand geselecteerd',
  'ex : utilise le vouvoiement, utilise un vocabulaire compréhensible par la cible': 'Bijv.: gebruik formele aanspreekvorm en een begrijpelijke woordenschat voor de doelgroep.',
  '🧠 Créer un agent IA': '🧠 Een AI-agent aanmaken',
  '🧠 Modifier un agent IA': '🧠 Een AI-agent bewerken',
  'Ex : AMF (Autorité des Marchés Financiers).': 'Bijv.: AMF (Franse Autoriteit Financiële Markten).',
  'Ex: bio, écologique, nom des concurrents': 'Bijv.: biologisch, ecologisch, namen van concurrenten.',
  'Détailler le plus possible la structure attendue à l\'aide d\'axes de rédaction pour guider l\'IA sur les sujets à traiter et dans quel ordre': 'Geef zoveel mogelijk details over de gewenste structuur om de AI te begeleiden in de onderwerpen en hun volgorde.',
  'Ajouter des éléments que l\'IA doit ou ne pas faire ou mentionner': 'Voeg elementen toe die de AI wel of niet moet doen of vermelden.',
  'Ex: prêt-à-porter féminin': 'Bijv.: damesmode',
  'Ex: Rédacteur SEO': 'Bijv.: SEO-schrijver',
  'Indiquer la liste des urls sur lesquels l\'IA peut s\'appuyer': 'Geef de lijst met URL’s waarop de AI zich kan baseren.',
  'Créez, optimisez, performez : votre contenu prend une nouvelle dimension.': 'Creëer, optimaliseer, presteer: uw content krijgt een nieuwe dimensie.',
  'La création de contenu n\'a jamais été aussi smart.': 'Contentcreatie is nog nooit zo slim geweest.',
  'Boostez votre productivité grâce à la puissance multi-IA. Comparez et combinez les meilleures propositions issues de plusieurs LLM, puis optimisez-les grâce à un score de contenu en temps réel (SEO, lisibilité, pertinence)': 'Boost uw productiviteit met de kracht van multi-AI. Vergelijk en combineer de beste voorstellen van verschillende LLM’s en optimaliseer ze met een realtime score (SEO, leesbaarheid, relevantie).',
  'Je crée mon premier contenu SEO friendly': 'Ik maak mijn eerste SEO-vriendelijke content.',
  'Veuillez coller le texte source....': 'Plak hier de brontekst die u wilt vertalen…',
  'Enrichir': 'Verrijken',
  'Veuillez d\'abord sélectionner un site web': 'Selecteer eerst een website.',

  "🎯 Commencez ici": "🎯 Begin hier",
  "Ajoutez ou sélectionnez le site web que vous souhaitez suivre.": "Voeg de website toe die u wilt volgen, of selecteer hem.",
  "📝 Derniers contenus créés": "📝 Laatst aangemaakte content",
  "Retrouvez ici les derniers contenus créés pour le site sélectionné.": "Hier vindt u de recent aangemaakte content voor de geselecteerde site.",
  "Cliquez sur un texte pour consulter sa fiche détaillée.": "Klik op een tekst om de details te bekijken.",
  "📁 Derniers projets créés": "📁 Laatst aangemaakte projecten",
  "Accédez rapidement aux derniers projets lancés pour ce site.": "Krijg snel toegang tot de recent gestarte projecten voor deze site.",
  "Cliquez sur un projet pour voir son avancement et les contenus associés.": "Klik op een project om de voortgang en de gekoppelde content te bekijken.",
  "📊 Suivi de vos projets": "📊 Projectopvolging",
  "Visualisez la répartition de vos projets : en cours, en retard ou validés.": "Bekijk de status van uw projecten: lopend, vertraagd of afgerond.",
  "Une vue d’ensemble claire pour suivre l’état global de votre production.": "Een duidelijk overzicht van de algemene voortgang van uw productie.",
  "📑 Statut d’avancement des contenus": "📑 Status van de contentvoortgang",
  "Suivez ici la répartition de vos contenus : brouillons, livrés et publiés.": "Volg hier uw content: concepten, geleverd en gepubliceerd.",
  "Idéal pour identifier rapidement où concentrer vos efforts.": "Ideaal om snel te bepalen waar u prioriteit moet geven.",
  "📅 Textes publiés par mois": "📅 Gepubliceerde teksten per maand",
  "Visualisez le nombre de textes publiés chaque mois pour le site sélectionné.": "Bekijk het aantal teksten dat elke maand wordt gepubliceerd voor de geselecteerde site.",
  "Suivez ainsi votre rythme de déploiement dans le temps.": "Volg zo uw publicatieritme doorheen de tijd.",
  "⭐ Top mots-clés": "⭐ Top zoekwoorden",
  "Découvrez vos 5 mots-clés les plus performants issus de la Search Console.": "Ontdek uw 5 best presterende zoekwoorden uit de Search Console.",
  "Comparez leur position, les clics actuels et les clics de l’année précédente.": "Vergelijk hun positie, huidige klikken en klikken van het vorige jaar.",
  "📈 Activer le suivi du trafic": "📈 Verkeerstracking activeren",
  "Ajoutez notre adresse e-mail à votre Search Console pour activer cette analyse.": "Voeg ons e-mailadres toe aan uw Search Console om deze analyse te activeren.",
  "Vous pourrez ensuite suivre l’évolution de votre trafic directement dans Typix.": "Daarna kunt u uw verkeer rechtstreeks in Typix volgen.",
  "🏠 Tableau de bord": "🏠 Dashboard",
  "Revenez à la vue globale : indicateurs clés, contenus récents, projets et performances de votre site.": "Ga terug naar het algemene overzicht: kernindicatoren, recente content, projecten en prestaties van uw site.",
  "🤖 Agents IA": "🤖 AI-agenten",
  "Configurez et pilotez vos agents IA pour automatiser la rédaction ainsi que la traduction et gagner du temps sur vos contenus.": "Configureer en beheer uw AI-agenten om schrijven en vertalen te automatiseren en tijd te besparen.",
  "✍️ Rédaction IA": "✍️ AI-schrijven",
  "Accédez aux générateurs IA : fiches produit, fiches GMB, pages catégories et autres contenus optimisés.": "Toegang tot AI-generatoren: productfiches, GMB-fiches, categoriepagina’s en andere geoptimaliseerde content.",
  "🌍 Traduction IA": "🌍 AI-vertaling",
  "Traduisez vos contenus en plusieurs langues en quelques clics tout en conservant la cohérence SEO.": "Vertaal uw content in meerdere talen in enkele klikken terwijl u SEO-consistentie behoudt.",
  "➕ Créer un projet": "➕ Project aanmaken",
  "Lancez un nouveau projet de contenus en quelques secondes et suivez ensuite son avancement.": "Start een nieuw contentproject in enkele seconden en volg daarna de voortgang.",
  "📂 Gestion des projets": "📂 Projectbeheer",
  "Accédez à vos projets non attribués, en cours, en retard ou validés pour suivre leur progression.": "Bekijk uw niet-toegewezen, lopende, vertraagde of afgeronde projecten om hun voortgang te volgen.",
  "👤 Mon profil": "👤 Mijn profiel",
  "Modifiez vos informations personnelles.": "Wijzig uw persoonlijke gegevens.",
  "🧑‍🤝‍🧑 Gestion des utilisateurs": "🧑‍🤝‍🧑 Gebruikersbeheer",
  "Invitez de nouveaux membres, gérez leurs droits et organisez les équipes.": "Nodig nieuwe leden uit, beheer hun rechten en organiseer uw teams.",
  "❓ Mon guide": "❓ Mijn gids",
  "Relancez ce guide interactif à tout moment pour retrouver les principales fonctionnalités de Typix.": "Start deze interactieve gids op elk moment opnieuw om de belangrijkste functies van Typix te bekijken.",
  'Mon guide': 'Mijn gids',
  'Se déconnecter': 'Uitloggen',
  "L'adresse email est obligatoire.": "Het e-mailadres is verplicht.",
  "Le nom est obligatoire.": "De achternaam is verplicht.",
  "Le prénom est obligatoire.": "De voornaam is verplicht.",
  "Le mot de passe est obligatoire.": "Het wachtwoord is verplicht.",
  "La confirmation est obligatoire.": "De bevestiging is verplicht.",
  "Les mots de passe ne correspondent pas.": "De wachtwoorden komen niet overeen.",
  "Récapitulatif": "Samenvatting",
  "Quitter la création": "Aanmaken verlaten",
  "Objectif du projet": "Projectdoel",
  "Mode de production": "Productiemodus",
  "Répartition du travail": "Werkverdeling",
  "Contexte éditorial": "Redactionele context",
  "Rédaction": "Schrijven",
  "Traduction": "Vertaling",
  "Créer du contenu original": "Originele content maken",
  "Traduire un contenu existant": "Bestaande content vertalen",
  "Identification du projet": "Projectidentificatie",
  "Nom du projet": "Projectnaam",
  "Vous pourrez modifier le nom plus tard": "U kunt de naam later wijzigen",
  "URL du site": "Website-URL",
  "Langue": "Taal",
  "Sélectionner une langue": "Selecteer een taal",
  "Nombre de textes": "Aantal teksten",
  "12 textes disponibles": "12 beschikbare teksten",
  "Chef de projet": "Projectmanager",
  "Aucun chef de projet assigné au siteweb": "Geen projectmanager toegewezen aan de website",
  "Sélectionner un chef de projet": "Selecteer een projectmanager",
  "Date limite du projet": "Projectdeadline",
  "Sélectionner une date limite": "Selecteer een deadline",
  "Suivant": "Volgende",
  "Retour": "Terug",
  "Définissez l'objectif et le cadre général de votre projet.": "Definieer het doel en het algemene kader van uw project.",
  "IA": "AI",
  "Production généré par IA": "AI-gegenereerde productie",
  "Rédacteur": "Schrijver",
  "Production Rédacteur par IA": "Schrijverproductie door AI",
  "IA + revue humaine": "AI + menselijke review",
  "IA avec validation humaine.": "AI met menselijke validatie.",
  "Répartissez les textes de votre projet entre vous et d'éventuels rédacteurs.": "Verdeel de teksten van uw project tussen u en eventuele schrijvers.",
  "L'attribution à un rédacteur est optionnelle.": "Toewijzing aan een schrijver is optioneel.",
  "Agent IA": "AI-agent",
  "Vous pourrez changer d'agent plus tard": "U kunt de agent later wijzigen",
  "Veuillez d'abord sélectionner un site web": "Selecteer eerst een website",
  "Sélectionnez le mode IA": "Selecteer AI-modus",
  "Aucun agent disponible": "Geen agent beschikbaar",
  "Sélectionner un agent IA": "Selecteer een AI-agent",
  "Format du contenu": "Contentformaat",
  "Sélectionner un format": "Selecteer een formaat",
  "Nombre de mots par texte": "Aantal woorden per tekst",
  "Format personnalisé": "Aangepast formaat",
  "définir le nombre de mots": "aantal woorden definiëren",
  "mots": "woorden",
  "Options avancées": "Geavanceerde opties",
  "Enrichissement du contenu": "Contentverrijking",
  "Génération Image": "Afbeeldinggeneratie",
  "Nombre d’images": "Aantal Afbeeldingen",
  "Définir le nombre d’images": "Aantal afbeeldingen instellen",
  "Consomment des crédits supplémentaires": "Verbruiken extra credits",
  "IA augmentée par vos données": "AI uitgebreid met uw gegevens",
  "Sélectionnez les personnes en charge de la relecture des contenus générés par l'IA et répartissez": "Selecteer de personen die verantwoordelijk zijn voor de review van AI-gegenereerde content en verdeel",
  "les textes à valider.": "de teksten die gevalideerd moeten worden.",
  "Le relecteur peut apporter des corrections et ajustements ciblés dans la limite de mots définie,": "De revisor kan gerichte correcties en aanpassingen aanbrengen binnen de gedefinieerde woordlimiet,",
  "sans réécrire entièrement le contenu.": "zonder de content volledig te herschrijven.",
  "Contexte éditorial & brief détaillé du projet": "Redactionele context & gedetailleerd projectbrief",
  "Ajouter des informations contextuelles pour guider et enrichir la production des contenus.": "Voeg contextuele informatie toe om de contentproductie te begeleiden en te verrijken.",
  "Gap sémantique": "Semantische kloof",
  "optionnel": "optioneel",
  "Brief détaillé": "Gedetailleerd brief",
  "Lien drive...": "Drive-link...",
  "Lancer le projet": "Project starten",
  "Nom du projet existant": "Projectnaam bestaat al",
  "Un projet avec ce nom existe déjà dans votre espace.": "Een project met deze naam bestaat al in uw ruimte.",
  "Merci de choisir un nom différent pour continuer.": "Kies een andere naam om door te gaan.",
  "Erreur lors de la création du projet. Veuillez réessayer.": "Fout bij het aanmaken van het project. Probeer het opnieuw.",
  "Félicitations !": "Gefeliciteerd!",
  "Votre projet a été créé avec succès !": "Uw project is succesvol aangemaakt!",
  "Voir le projet": "Project bekijken",
  "Fermer": "Sluiten",
  "Paramètres du compte": "Accountinstellingen",
  "Site web": "Website",
  "Langue du site": "Website-taal",
  "textes": "teksten",
  "Deadline": "Deadline",
  "Type": "Type",
  "Rédacteur": "Schrijver",
  "Moi (par défaut)": "Ik (standaard)",
  "Livraison le": "Levering op",
  "À venir": "Binnenkort",
  "Production généré par IA": "AI-gegenereerde productie",
  "Agent": "Agent",
  "Format": "Formaat",
  "Enrichissement du contenu activé": "Contentverrijking geactiveerd",
  "Relecteur": "Revisor",
  "texte": "tekst",
  "Limite de modification": "Wijzigingslimiet",
  "Aucune attribution": "Geen toewijzing",
  "Aucun élément ajouté": "Geen element toegevoegd",
  "janvier": "januari",
  "février": "februari",
  "mars": "maart",
  "avril": "april",
  "mai": "mei",
  "juin": "juni",
  "juillet": "juli",
  "août": "augustus",
  "septembre": "september",
  "octobre": "oktober",
  "novembre": "november",
  "décembre": "december",
  "à": "tot",
  "mots minimum": "minimum woorden",
  "mots maximum": "maximum woorden",
  "Status de validation des projets": "Projectvalidatiestatus",
  "Statut d'avancement des contenus": "Voortgangsstatus van inhoud:",
  "Total des contenus": "Totaal inhoud:",
  "Non attribué": "Niet toegewezen",
  "Évolution des performances": "Prestatie-evolutie",
  "Position": "Positie",
  "Nombre de textes publiés": "Aantal gepubliceerde teksten",
  "Espace de travail AI": "AI-werkruimte",
  "Mise à jour 1.2": "Update 1.2",
  "Découvrez les dernières fonctionnalités, optimisations et correctifs.": "Ontdek de nieuwste functies, optimalisaties en fixes.",
  "Projet créé": "Project aangemaakt",
  "Votre projet a bien été créé.": "Uw project is succesvol aangemaakt.",
  "Vous pouvez commencer à travailler dessus dès maintenant.": "U kunt er direct mee aan de slag gaan.",
  "Sélectionnez le mode IA": "Selecteer AI-modus",
  "Aucun agent disponible": "Geen agent beschikbaar",
  "Sélectionner un agent IA": "Selecteer een AI-agent",
  "Sélectionner un format": "Selecteer een formaat",
  "Veuillez d'abord sélectionner un site web": "Selecteer eerst een website",

  ///
  'Nouveau contenu': 'Nieuwe inhoud',
  'Génération en cours...': 'Generatie bezig...',
  'Optimisation en cours...': 'Optimalisatie bezig...',
  'Traduction en cours...': 'Vertaling bezig...',
  'En lignes': 'Online',
  'filtres': 'Filters',
  'trier par': 'sorteren op',
  'Score décroissant': 'Afnemende score',
  'Score croissant': 'Toenemende score',
  'Date de création': 'Aanmaakdatum',
  'Date de mise à jour': 'Laatste update',
  'Date récente': 'Meest recente datum',
  'Date ancienne': 'Oudste datum',
  'Mots clés': 'Trefwoorden',
  'Éditeur': 'Editor',
  'Créateur': 'Maker',
  'Rédacteurs': 'Auteurs',
  'Réinitialisé par défaut': 'Standaardinstellingen herstellen',
  'Mode de rédaction': 'Schrijfmodus',
  'Agent AI utilisé': 'Gebruikte AI-agent',
  'Textes en brouillons': 'Concepten',
  'Modèle': 'Model',
  'Paramètres du projet': 'Projectinstellingen',
  'Avancement': 'Status',
  'Progression': 'Voortgang',
  'Aucun texte disponible': 'Geen tekst beschikbaar',
  'Détails du projet': 'Projectdetails',
  'Page {{current}} sur {{total}}': 'Pagina {{current}} van {{total}}',
  'Moteur LLM': 'LLM-engine',
  'Rédiger un contenu': 'Inhoud schrijven',
  'Traduire un contenu': 'Inhoud vertalen',
  'Optimiser un contenu': 'Inhoud optimaliseren',
  'Générer un contenu': 'Inhoud genereren',

  'Créez un texte pour un mot-clé spécifique avec un formulaire guidé':
    'Maak een tekst voor een specifiek trefwoord met een begeleid formulier',

  'Traduire un texte spécifique avec un formulaire guidé':
    'Vertaal een specifieke tekst met een begeleid formulier',

  'Générez plusieurs textes en important un fichier Excel':
    'Genereer meerdere teksten door een Excel-bestand te importeren',

  'Rédiger un lot de contenus': 'Een batch inhoud schrijven',
  'Traduire un lot de contenus': 'Een batch inhoud vertalen',
  'Enrichir un contenu': 'Inhoud verrijken',

  'Optimisez un texte spécifique avec un formulaire guidé':
    'Optimaliseer een specifieke tekst met een begeleid formulier',

  'Nombre total de textes alloués au projet':
    'Totaal aantal teksten toegewezen aan het project',

  'Vous pourrez changer le format du contenu plus tard':
    'U kunt het inhoudsformaat later wijzigen',

  'Saisissez chaque mot-clé suivi de sa fréquence entre parenthèses, puis appuyez sur Entrée. Exemple : chaussures(3)':
    'Voer elk trefwoord in gevolgd door de frequentie tussen haakjes en druk op Enter. Voorbeeld: schoenen(3)',

  'Ex: voiture(5), électrique(3), autonomie(8)':
    'Bijv.: auto(5), elektrisch(3), actieradius(8)',

  'URLs des pages à lier (séparées par des virgules)':
    'URL\'s van te koppelen pagina\'s (gescheiden door komma\'s)',

  'Besoin d\'aide pour préparer votre fichier ?':
    'Heeft u hulp nodig bij het voorbereiden van uw bestand?',

  'Télécharger le modèle (Excel)':
    'Sjabloon downloaden (Excel)',

  'Déposez votre fichier ici':
    'Plaats uw bestand hier',

  'Glissez-déposez votre fichier Excel':
    'Sleep en zet uw Excel-bestand neer',

  'ou cliquez pour parcourir':
    'of klik om te bladeren',

  'Formats acceptés : .xlsx, .xls (max 10 Mo)':
    'Geaccepteerde formaten: .xlsx, .xls (max. 10 MB)',

  'Parcourir les fichiers':
    'Bestanden doorbladeren',

  'Ex: télépéage automatique':
    'Bijv.: automatische tolbetaling',

  'Générer le contenu': 'Inhoud genereren',
  'Lancer la génération': 'Generatie starten',
  'Commencer la traduction': 'Vertaling starten',
  'Lancer la traduction': 'Vertaling starten',

  'Partager': 'Delen',
  'Telecharger le texte': 'Tekst downloaden',
  'Modifier le projet': 'Project bewerken',
  'Modifiez les détails de votre projet ici.':
    'Bewerk hier de details van uw project.',

  'Général': 'Algemeen',
  'Allocation des textes': 'Teksttoewijzing',
  'Sélectionner un format du contenu': 'Selecteer een inhoudsformaat',
  'Allocation aux rédacteurs': 'Toewijzing aan auteurs',

  '{{count}} textes disponibles':
    '{{count}} beschikbare teksten',

  'Sélectionner un rédacteur': 'Selecteer een auteur',
  'Nom du rédacteur': 'Naam van de auteur',
  'Date limite': 'Deadline',
  'texte restant': 'resterende tekst',
  'textes alloués': 'toegewezen teksten',

  'Article court - 300 mots': 'Kort artikel – 300 woorden',
  'Article moyen - 600 mots': 'Gemiddeld artikel – 600 woorden',
  'Article long - 1000 words': 'Lang artikel – 1000 woorden',
  'Youtube - 350 mots': 'YouTube – 350 woorden',
  'Linkedin - 200 mots': 'LinkedIn – 200 woorden',
  'X - 150 mots': 'X – 150 woorden',
  'Personnalisé': 'Aangepast',

  'Voir plus': 'Meer bekijken',
  ' à votre ': ' aan uw ',
  '{{count}} textes à livrer':
    '{{count}} te leveren teksten',

'Nous contacter': 'Neem contact met ons op',
'Vous avez une question ou un problème ? Contactez-nous et nous vous répondrons dans les plus brefs délais.': 'Heeft u een vraag of een probleem? Neem contact met ons op en wij nemen zo snel mogelijk contact met u op.',
'Sujet': 'Onderwerp',
'Message': 'Bericht',
'Soumettre ma demande': 'Mijn verzoek indienen',
'Veuillez sélectionner un sujet': 'Selecteer een onderwerp',
'Décrivez votre demande en détail...': 'Beschrijf uw verzoek in detail...',
'Sélectionnez un sujet': 'Selecteer een onderwerp',
'Autre': 'Anders',
'Feedback': 'Feedback',
'Question': 'Vraag',
'Bug': 'Bug',
'Le message doit contenir au moins 10 caractères': 'Het bericht moet minimaal 10 tekens bevatten',
'Votre message a été envoyé avec succès. Nous vous répondrons dans les plus brefs délais.': 'Uw bericht is succesvol verzonden. Wij nemen zo snel mogelijk contact met u op.',
'Votre demande a bien été transmise à notre équipe support, qui vous répondra dans les plus brefs délais.': 'Uw verzoek is doorgestuurd naar ons supportteam, dat zo snel mogelijk contact met u zal opnemen.',
'Envoi en cours...': 'Bezig met verzenden...',
'Fermer': 'Sluiten',
'Créer un nouvel agent AI': 'Nieuwe AI-agent aanmaken',
'Mission de l\'agent': 'Missie van de agent',
'L\'agent générera du contenu original à partir de vos consignes.': 'De agent genereert originele inhoud op basis van uw instructies.',
'Informations générales': 'Algemene informatie',
'Informations principales': 'Belangrijkste informatie',
'Ton & audience': 'Toon & doelgroep',
'Structure & rédaction': 'Structuur & redactie',
'Base de connaissances': 'Kennisbank',
'Construction du contenu': 'Contentopbouw',
'Structure attendu': 'Verwachte structuur',
'Cadre lexical': 'Lexicaal kader',
'Personnalisation avancée': 'Geavanceerde personalisatie',
'Base de connaissance locale en ligne': 'Online lokale kennisbank',
'Glissez-déposez votre fichier': 'Sleep uw bestand hierheen',
'Base de connaissance': 'Kennisbank',
'Indiquez la liste des urls sur lesquels l’IA peut s’appuyer': 'Geef de lijst met URL\'s op waarop de AI kan vertrouwen',
'Définissez le positionnement éditorial de votre agent afin qu’il adapte son ton,': 'Definieer de redactionele positionering van uw agent zodat deze zijn toon aanpast,',
'sa cible et son vocabulaire à votre activité.': 'zijn doelgroep en zijn woordenschat aan uw activiteit.',
'caractères': 'tekens',
};
